// 由 src/views/smart-workbench/index.vue 的 methods 拆分而来，请勿在此文件之外重复定义同名方法。
// 报告编排与流式渲染：毛利/链式/竞争力/客户结构/CEO 半年总结等分析触发与卡片渲染
// 方法体与原文件逐字节一致（仅调整文件归属）。
export default {
  methods: {
    async handleSmartAnalysis(type) {
      // 流式输出守卫：正在输出时静默拒绝，但重新打开抽屉以便查看
      if (this.$store.state.cosmoClaw.isStreaming) {
        if (this.useDrawer) {
          this.drawerVisible = true
        }
        return
      }
      // 节流：1.5秒内的连点静默忽略
      const now = Date.now()
      if (now - this.lastSmartAnalysisTime < 1500) {
        return
      }
      this.lastSmartAnalysisTime = now

      this.clearSmartAnalysisTimers()
      this.resetSmartFlowCard()
      this.selectedAgent = null
      this.clawMode = 'assistant'
      this.$store.commit('cosmoClaw/SET_IFRAME_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_IFRAME_ITEMS', [])
      this.$store.commit('cosmoClaw/SET_IS_STREAMING', false)
      this.$store.commit('cosmoClaw/SET_CURRENT_RUN_ID', null)

      // 抽屉模式：先打开抽屉，等待抽屉内聊天容器出现后再执行分析
      if (this.useDrawer) {
        this.drawerVisible = true
        await this.$nextTick()
        // el-drawer 内部 body 使用 v-if="rendered" 控制渲染，
        // 但由于 drawer 挂载时 visible=false，rendered 不会被设为 true，
        // 导致插槽内容（#drawer-chat / CosmoClawChat）永远不在 DOM 中。
        // 这里强制将 rendered 置为 true 以触发内容渲染。
        const drawerComp = this.$refs && this.$refs.rightChatPanel && this.$refs.rightChatPanel.$refs.drawer
        if (drawerComp) {
          drawerComp.rendered = true
          drawerComp.$forceUpdate()
        }
        await this.$nextTick()
        await new Promise((resolve) => {
          const checkDrawer = () => {
            if (document.getElementById('drawer-chat')) {
              resolve()
            } else {
              setTimeout(checkDrawer, 50)
            }
          }
          checkDrawer()
        })
      }
      // 清除DOM中残留的折叠思考气泡
      this.$nextTick(() => {
        document
          .querySelectorAll('[id^="thinking-collapsed-"]')
          .forEach((el) => el.remove())
      })

      // 真实智能分析：企业战情室/待决策事项/业务链群经营分析卡片列表触发真实聊天
      if (
        typeof type === 'object' &&
        type.content &&
        (type.type === 'enterpriseWarRoom' || type.type === 'pendingDecision' || type.type === 'businessChainAnalysis')
      ) {
        this.$store.commit('cosmoClaw/SET_LOCAL_DEMO_MODE', false)
        // 保留已有会话记录，不清除

        // 发送真实聊天消息
        const store = this.$store
        const currentSessionKey = store.state.cosmoClaw.currentSessionKey
        if (!currentSessionKey) {
          const sessionKey = await store.dispatch('cosmoClaw/createNewSession', {
            agentName: store.state.cosmoClaw.currentAgentName
          })
          setTimeout(() => {
            store.dispatch('cosmoClaw/sendMessage', {
              content: type.content,
              sessionKey
            })
          }, 500)
        } else {
          this.$nextTick(() => {
            store.dispatch('cosmoClaw/sendMessage', {
              content: type.content
            })
          })
        }
        return
      }

      // Demo 模式（其他智能分析场景）
      this.$store.commit('cosmoClaw/SET_LOCAL_DEMO_MODE', true)
      if (type === 'grossMargin') {
        await this.runGrossMarginAnalysis()
      } else if (type === 'pendingDecisionGrossMargin') {
        await this.runPendingDecisionGrossMarginAnalysis()
      } else if (type === 'enterpriseWarRoom') {
        await this.runEnterpriseBriefAnalysis()
      } else if (type === 'csoEnterpriseWarRoom') {
        await this.runCsoEnterpriseBriefAnalysis()
      } else if (type === 'pendingDecision') {
        await this.runPendingDecisionAnalysis()
      } else if (type === 'csoPendingDecisionBom') {
        await this.runCsoPendingBomAnalysis()
      } else if (typeof type === 'object') {
        if (type.name && type.name.includes('毛利率') && !type.forceRealChat) {
          await this.runProfitMarginAbnormalAnalysis()
        } else if (type.name) {
          // 非毛利率指标：触发真实智能分析对话
          this.$store.commit('cosmoClaw/SET_LOCAL_DEMO_MODE', false)
          const content = `分析${type.name}指标，一句话总结指标运行情况，生成今年1月至本月的指标数据统计和去年同期数据对比图表。`
          const store = this.$store
          const currentSessionKey = store.state.cosmoClaw.currentSessionKey
          if (!currentSessionKey) {
            const sessionKey = await store.dispatch('cosmoClaw/createNewSession', {
              agentName: store.state.cosmoClaw.currentAgentName
            })
            setTimeout(() => {
              store.dispatch('cosmoClaw/sendMessage', { content, sessionKey })
            }, 500)
          } else {
            this.$nextTick(() => {
              store.dispatch('cosmoClaw/sendMessage', { content })
            })
          }
        }
      }
    },
    /** 战情室"提问"按钮：创建新会话并发送消息 */
    async handleWarRoomStartChat(content) {
      if (!content || !content.trim()) return
      // 流式输出守卫：正在输出时静默拒绝
      if (this.$store.state.cosmoClaw.isStreaming) {
        return
      }
      // 节流：1.5秒内的连点静默忽略
      const now = Date.now()
      if (now - this.lastSmartAnalysisTime < 1500) {
        return
      }
      this.lastSmartAnalysisTime = now

      this.clearSmartAnalysisTimers()
      this.resetSmartFlowCard()
      this.selectedAgent = null
      this.clawMode = 'assistant'
      this.$store.commit('cosmoClaw/SET_IFRAME_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_AGENT_PLAZA_VISIBLE', false)
      this.$store.commit('cosmoClaw/SET_IS_STREAMING', false)
      this.$store.commit('cosmoClaw/SET_CURRENT_RUN_ID', null)
      this.$store.commit('cosmoClaw/SET_LOCAL_DEMO_MODE', false)

      // 抽屉模式：先打开抽屉
      if (this.useDrawer) {
        this.drawerVisible = true
        await this.$nextTick()
        const drawerComp = this.$refs && this.$refs.rightChatPanel && this.$refs.rightChatPanel.$refs.drawer
        if (drawerComp) {
          drawerComp.rendered = true
          drawerComp.$forceUpdate()
        }
        await this.$nextTick()
        await new Promise((resolve) => {
          const check = () => {
            if (document.getElementById('drawer-chat')) resolve()
            else setTimeout(check, 50)
          }
          check()
        })
      }

      const store = this.$store
      // 始终创建新会话
      const sessionKey = await store.dispatch('cosmoClaw/createNewSession', {
        agentName: store.state.cosmoClaw.currentAgentName
      })
      setTimeout(() => {
        store.dispatch('cosmoClaw/sendMessage', {
          content: content.trim(),
          sessionKey
        })
      }, 500)
    },
    async runGrossMarginAnalysis() {
      const analysisConfig = await this.fetchGrossMarginAnalysisConfig()
      const summary = analysisConfig.summary || {}
      const thinkingSteps = this.getGrossMarginThinkingSteps(analysisConfig)
      this.addSmartFlowHistory(this.$t('workbench.smartGrossMargin'))
      this.$store.commit('cosmoClaw/SET_MESSAGES', [
        this.createLocalMessage('user', this.$t('workbench.smartGrossMargin'))
      ])
      this.runSmartFlowProgress(
        {
          title: summary.title || this.$t('workbench.smartGrossMargin'),
          status: summary.description || this.$t('workbench.statusInProgress'),
          steps: thinkingSteps,
          interval: 700,
          finalBody: this.getGrossMarginAnalysisContent(analysisConfig),
          finalOptions: {
            status: this.$t('workbench.statusPending'),
            currentStep: this.$t('workbench.statusGrossMarginComplete')
          }
        },
        1500
      )
    },
    runChainBreakdown(type) {
      if (type === 'performance') {
        this.triggerChainPerformanceBreakdown()
      } else {
        this.triggerChainRevenueBreakdown()
      }
    },
    triggerChainRevenueBreakdown(staticMsgId) {
      const uniqueSuffix = staticMsgId ? '_' + String(staticMsgId).slice(-6) : '_' + Date.now()
      const reportId = 'chain-revenue-' + uniqueSuffix
      const CHAIN_GROUPS = [
        {
          name: '智能制造',
          actual: 15442.3684,
          lastYear: 13890.0,
          target: 24478.3871,
          owner: '谢海琴'
        },
        {
          name: '智能产线',
          actual: 20327.9464,
          lastYear: 18560.0,
          target: 26390.9677,
          owner: '丁斌'
        },
        {
          name: '机器视觉',
          actual: 1176.753,
          lastYear: 1080.0,
          target: 4302.9032,
          owner: '\u738b\u66be'
        },
        {
          name: '化工行业',
          actual: 2142.1309,
          lastYear: 1960.0,
          target: 5668.7097,
          owner: '张乐交'
        },
        {
          name: '工赋平台',
          actual: 4228.595,
          lastYear: 3860.0,
          target: 4744.8387,
          owner: '刁兴全'
        },
        {
          name: '智慧能源',
          actual: 18662.8261,
          lastYear: 17000.0,
          target: 25641.9355,
          owner: '邵凯'
        },
        {
          name: '碳索能源',
          actual: 37855.5928,
          lastYear: 34500.0,
          target: 40550.3871,
          owner: '张智权'
        },
        {
          name: 'AIOT解决方案',
          actual: 270398.3215,
          lastYear: 242132.52,
          target: 267096.7742,
          owner: '侯正领'
        }
      ]
      const totalActual = 368558.696
      const totalLastYear = 312982.52
      const yoyChange = totalActual - totalLastYear
      const yoyRate = ((yoyChange / totalLastYear) * 100).toFixed(1)
      const fmt = (v) => Number(v).toLocaleString('en-US')

      const title = '收入解构分析'

      const formatNumber = (v) => (v >= 0 ? '+' : '') + Number(v).toLocaleString('en-US')

      const chainRows = CHAIN_GROUPS.map((g) => {
        const yoy = g.actual - g.lastYear
        const yoyRateVal = ((yoy / g.lastYear) * 100).toFixed(1)
        return { ...g, yoy, yoyRate: yoyRateVal }
      })

      const topLifter = chainRows.reduce(
        (best, g) => (g.yoy > (best?.yoy || -Infinity) ? g : best),
        chainRows[0]
      )
      const bottomLagger = chainRows.reduce(
        (worst, g) => (g.yoy < (worst?.yoy || Infinity) ? g : worst),
        chainRows[0]
      )

      const section2Id = `chain-revenue-summary-${reportId}`

      const body = `
        <div id="chain-revenue-report-${reportId}" style="margin-top:2px;display:flex;flex-direction:column;gap:10px;">
          <style>@keyframes chain-revenue-spin-${reportId}{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}</style>
          <div id="chain-revenue-section-0-${reportId}" style="padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(74,95,243,0.08),rgba(14,165,233,0.05));border:1px solid rgba(74,95,243,0.16);display:none;">
            <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4A5FF3" stroke-width="2"><path d="M20 7h-9M14 17H5m11 0a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2m9-9a2 2 0 0 1 2 2v3.5a2.5 2.5 0 0 1-2.5 2.5H14"/></svg>
              <span id="chain-revenue-s0-label-${reportId}" style="font-size:12px;font-weight:600;color:#4A5FF3;"></span>
            </div>
            <div id="chain-revenue-s0-title-${reportId}" style="font-size:14px;font-weight:700;color:#1f2937;margin-bottom:4px;"></div>
            <div id="chain-revenue-s0-date-${reportId}" style="font-size:11px;color:#94a3b8;"></div>
          </div>

          <div id="chain-revenue-section-1-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div id="chain-revenue-s1-loading-${reportId}" style="display:flex;height:60px;align-items:center;justify-content:center;gap:10px;">
              <div style="width:20px;height:20px;border:3px solid #e8ecf0;border-top:3px solid #4A5FF3;border-radius:50%;animation:chain-revenue-spin-${reportId} 0.8s linear infinite;"></div>
              <span style="font-size:11px;color:#94a3b8;">正在加载经营数据...</span>
            </div>
            <div id="chain-revenue-s1-content-${reportId}" style="display:none;">
              <div style="display:flex;gap:10px;">
                <div style="flex:1;padding:12px;border-radius:10px;background:#f0fdf4;text-align:center;">
                  <div style="font-size:18px;font-weight:800;color:#0aa66a;">368,559</div>
                  <div style="font-size:10px;color:#64748b;margin-top:2px;">上半年实际收入</div>
                </div>
                <div style="flex:1;padding:12px;border-radius:10px;background:#eff6ff;text-align:center;">
                  <div style="font-size:18px;font-weight:800;color:#1f2937;">340,310</div>
                  <div style="font-size:10px;color:#64748b;margin-top:2px;">上年同期收入</div>
                </div>
                <div style="flex:1;padding:12px;border-radius:10px;background:${
  yoyChange >= 0 ? '#f0fdf4' : '#fef2f2'
};text-align:center;">
                  <div style="font-size:18px;font-weight:800;color:${
  yoyChange >= 0 ? '#0aa66a' : '#e54b3d'
};">28,248.7</div>
                  <div style="font-size:10px;color:#64748b;margin-top:2px;">同比增量</div>
                </div>
              </div>
            </div>
          </div>

          <div id="chain-revenue-section-2-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div id="${section2Id}" style="padding:12px 14px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;font-size:12px;color:#475569;line-height:1.8;min-height:44px;">
              <b style="color:#1f2937;">收入总览：</b><span id="${section2Id}-span"></span>
            </div>
          </div>

          <div id="chain-revenue-section-3-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div style="overflow-x:auto;">
              <table style="width:100%;border-collapse:collapse;font-size:12px;">
                <thead>
                  <tr style="background:#f8fafc;">
                    <th style="padding:8px 10px;text-align:left;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">链群</th>
                    <th style="padding:8px 10px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">本期收入</th>
                    <th style="padding:8px 10px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">同期收入</th>
                    <th style="padding:8px 10px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">同比增量</th>
                    <th style="padding:8px 10px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">同比率</th>
                    <th style="padding:8px 10px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">负责人</th>
                  </tr>
                </thead>
                <tbody id="chain-revenue-table-body-${reportId}"></tbody>
              </table>
            </div>
          </div>

          <div id="chain-revenue-section-4-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div id="chain-revenue-s4-loading-${reportId}" style="display:flex;height:60px;align-items:center;justify-content:center;gap:10px;">
              <div style="width:16px;height:16px;border:2px solid #e8ecf0;border-top:2px solid #4A5FF3;border-radius:50%;animation:chain-revenue-spin-${reportId} 0.8s linear infinite;"></div>
              <span style="font-size:11px;color:#94a3b8;">正在生成关键发现...</span>
            </div>
            <div id="chain-revenue-s4-content-${reportId}" style="display:none;">
              <div style="padding:12px 14px;border-radius:10px;background:linear-gradient(135deg,rgba(74,95,243,0.05),rgba(14,165,233,0.03));border:1px solid rgba(74,95,243,0.12);font-size:11px;color:#475569;line-height:1.7;">
                <b style="color:#4A5FF3;">关键发现</b><br>
                <span id="chain-revenue-finding-text-${reportId}"></span>
              </div>
            </div>
          </div>

          <div id="chain-revenue-section-5-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div style="display:flex;flex-wrap:wrap;gap:8px;">
              <button type="button" onclick="if(window.triggerIndustryCompetitiveness){window.triggerIndustryCompetitiveness();}" style="padding:7px 12px;border-radius:8px;background:linear-gradient(135deg,rgba(245,158,11,0.08),rgba(245,158,11,0.03));border:1px solid rgba(245,158,11,0.18);font-size:11px;color:#d97706;cursor:pointer;transition:all 0.2s ease;display:flex;align-items:center;gap:6px;" onmouseover="this.style.background='linear-gradient(135deg,rgba(245,158,11,0.14),rgba(245,158,11,0.06))';this.style.borderColor='rgba(245,158,11,0.28)'" onmouseout="this.style.background='linear-gradient(135deg,rgba(245,158,11,0.08),rgba(245,158,11,0.03))';this.style.borderColor='rgba(245,158,11,0.18)'">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"><path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg>
                <span>深度分析：行业解决方案竞争力不足</span>
              </button>
              <button type="button" onclick="if(window.triggerIndustryCompetitiveness){window.triggerIndustryCompetitiveness();}" style="padding:7px 12px;border-radius:8px;background:linear-gradient(135deg,rgba(245,158,11,0.08),rgba(245,158,11,0.03));border:1px solid rgba(245,158,11,0.18);font-size:11px;color:#d97706;cursor:pointer;transition:all 0.2s ease;display:flex;align-items:center;gap:6px;" onmouseover="this.style.background='linear-gradient(135deg,rgba(245,158,11,0.14),rgba(245,158,11,0.06))';this.style.borderColor='rgba(245,158,11,0.28)'" onmouseout="this.style.background='linear-gradient(135deg,rgba(245,158,11,0.08),rgba(245,158,11,0.03))';this.style.borderColor='rgba(245,158,11,0.18)'">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"><path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg>
                <span>深度分析：客户结构不好</span>
              </button>
              <button type="button" onclick="if(window.triggerIndustryCompetitiveness){window.triggerIndustryCompetitiveness();}" style="padding:7px 12px;border-radius:8px;background:linear-gradient(135deg,rgba(245,158,11,0.08),rgba(245,158,11,0.03));border:1px solid rgba(245,158,11,0.18);font-size:11px;color:#d97706;cursor:pointer;transition:all 0.2s ease;display:flex;align-items:center;gap:6px;" onmouseover="this.style.background='linear-gradient(135deg,rgba(245,158,11,0.14),rgba(245,158,11,0.06))';this.style.borderColor='rgba(245,158,11,0.28)'" onmouseout="this.style.background='linear-gradient(135deg,rgba(245,158,11,0.08),rgba(245,158,11,0.03))';this.style.borderColor='rgba(245,158,11,0.18)'">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"><path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg>
                <span>深度分析：全球布局能力没有建立起来</span>
              </button>
            </div>
          </div>
        </div>`

      const summaryText = `上半年八个业务链群实际收入 ${fmt(
        totalActual
      )} 万元，较上年同期 ${fmt(totalLastYear)} 万元，同比 ${formatNumber(
        yoyChange
      )} 万元（${yoyRate}%）。${topLifter.name} 贡献最大增量（${formatNumber(
        topLifter.yoy
      )} 万元），${bottomLagger.name} 降幅最大（${formatNumber(
        bottomLagger.yoy
      )} 万元）。`

      if (staticMsgId) {
        this.$store.commit('cosmoClaw/UPDATE_MESSAGE_CONTENT_BY_ID', {
          id: staticMsgId,
          content: body,
          richHtml: true
        })
        var s = this
        return new Promise(function (resolve) {
          s.$nextTick(function () {
            for (var si = 0; si <= 5; si++) {
              var el = s._findVisibleEl('chain-revenue-section-' + si + '-' + reportId)
              if (el) el.style.display = 'block'
            }
            var t = function (id, txt) {
              var e = s._findVisibleEl(id)
              if (e) e.textContent = txt
            }
            t('chain-revenue-s0-label-' + reportId, '业务链群收入解构')
            t('chain-revenue-s0-title-' + reportId, '卡奥斯上半年收入同比解构')
            t('chain-revenue-s0-date-' + reportId, '2026 年上半年 · 单位：万元')
            var l1 = s._findVisibleEl('chain-revenue-s1-loading-' + reportId)
            var c1 = s._findVisibleEl('chain-revenue-s1-content-' + reportId)
            if (l1) l1.style.display = 'none'
            if (c1) c1.style.display = 'block'
            var sp = s._findVisibleEl('chain-revenue-summary-' + reportId + '-span')
            if (sp) sp.textContent = summaryText
            var tb = s._findVisibleEl('chain-revenue-table-body-' + reportId)
            if (tb) {
              var rows = chainRows
                .map(function (g) {
                  return (
                    '<tr><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;font-weight:600;">' +
                    g.name +
                    '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#475569;text-align:right;">' +
                    fmt(g.actual) +
                    '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#475569;text-align:right;">' +
                    fmt(g.lastYear) +
                    '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:' +
                    (g.yoy >= 0 ? '#0aa66a' : '#e54b3d') +
                    ';">' +
                    formatNumber(g.yoy) +
                    '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:#1f2937;">' +
                    g.yoyRate +
                    '%</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#94a3b8;text-align:right;">' +
                    g.owner +
                    '</td></tr>'
                  )
                })
                .join('')
              var tr =
                '<tr style="font-weight:700;background:#f8fafc;"><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;">合计</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;text-align:right;">' +
                fmt(totalActual) +
                '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;text-align:right;">' +
                fmt(totalLastYear) +
                '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:' +
                (yoyChange >= 0 ? '#0aa66a' : '#e54b3d') +
                ';">' +
                formatNumber(yoyChange) +
                '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:#1f2937;">' +
                yoyRate +
                '%</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#94a3b8;text-align:right;"></td></tr>'
              tb.innerHTML = rows + tr
            }
            var l4 = s._findVisibleEl('chain-revenue-s4-loading-' + reportId)
            var c4 = s._findVisibleEl('chain-revenue-s4-content-' + reportId)
            if (l4) l4.style.display = 'none'
            if (c4) c4.style.display = 'block'
            var ftext =
              '• 同比增量最大：' +
              topLifter.name +
              '（' +
              formatNumber(topLifter.yoy) +
              ' 万元，' +
              topLifter.yoyRate +
              '%）\\n• 同比下降最显著：' +
              bottomLagger.name +
              '（' +
              formatNumber(bottomLagger.yoy) +
              ' 万元，' +
              bottomLagger.yoyRate +
              '%）\\n• 收入增长来源：' +
              chainRows.filter(function (g) {
                return g.yoy > 0
              }).length +
              ' 个链群实现同比增长\\n• ' +
              (yoyChange >= 0
                ? '整体收入较上年同期增长，增长质量需结合毛利率等盈利指标综合评估'
                : '整体收入较上年同期下降，需重点关注负增长链群的经营诊断')
            t('chain-revenue-finding-text-' + reportId, ftext)
            resolve()
          })
        })
      }
      this.addSmartFlowHistory(title)
      this.appendLocalMessage('assistant', body, true)
      this.persistMockMessage('assistant', '[mock:chain-revenue]')

      // 串行揭示：全部文字打印机效果，按顺序逐渐展示
      setTimeout(() => {
        // Section 0: 流式输出标题
        this.revealSection(`chain-revenue-section-0-${reportId}`, 'block')
        setTimeout(() => {
          this.typeWriterEffect(
            `chain-revenue-s0-label-${reportId}`,
            '业务链群收入解构',
            () => {
              this.typeWriterEffect(
                `chain-revenue-s0-title-${reportId}`,
                '卡奥斯上半年收入同比解构',
                () => {
                  this.typeWriterEffect(
                    `chain-revenue-s0-date-${reportId}`,
                    '2026 年上半年 · 单位：万元',
                    () => {
                      // Section 0 完毕 → Section 1（统计卡片，loading后展示）
                      this.revealSection(`chain-revenue-section-1-${reportId}`, 'block')
                      setTimeout(() => {
                        const loader = this._findVisibleEl(
                          `chain-revenue-s1-loading-${reportId}`
                        )
                        const content = this._findVisibleEl(
                          `chain-revenue-s1-content-${reportId}`
                        )
                        if (loader) loader.style.display = 'none'
                        if (content) content.style.display = 'block'
                        // Section 1 完毕 → Section 2（收入总览，打印机效果）
                        setTimeout(() => {
                          this.revealSection(
                            `chain-revenue-section-2-${reportId}`,
                            'block'
                          )
                          setTimeout(() => {
                            this.typeWriterEffect(
                              `${section2Id}-span`,
                              summaryText,
                              () => {
                                // Section 2 完毕 → Section 3（表格，loading后逐行加载）
                                this.revealSection(
                                  `chain-revenue-section-3-${reportId}`,
                                  'block'
                                )
                                setTimeout(() => {
                                  const tbody = this._findVisibleEl(
                                    `chain-revenue-table-body-${reportId}`
                                  )
                                  if (tbody) {
                                    // 一次性展示所有表格内容（不需要流式输出）
                                    const rows = chainRows
                                      .map(
                                        (g) => `
                              <tr>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;font-weight:600;">${
  g.name
}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#475569;text-align:right;">${fmt(
    g.actual
  )}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#475569;text-align:right;">${fmt(
    g.lastYear
  )}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:${
  g.yoy >= 0 ? '#0aa66a' : '#e54b3d'
};">${formatNumber(g.yoy)}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:#1f2937;">${
  g.yoyRate
}%</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#94a3b8;text-align:right;">${
  g.owner
}</td>
                              </tr>`
                                      )
                                      .join('')
                                    // 添加合计行
                                    const totalRow = `
                              <tr style="font-weight:700;background:#f8fafc;">
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;">合计</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;text-align:right;">${fmt(
    totalActual
  )}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;text-align:right;">${fmt(
    totalLastYear
  )}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:${
  yoyChange >= 0 ? '#0aa66a' : '#e54b3d'
};">${formatNumber(yoyChange)}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:#1f2937;">${yoyRate}%</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#94a3b8;text-align:right;"></td>
                              </tr>`
                                    tbody.innerHTML = rows + totalRow
                                    // 表格加载完成，滚动到聊天框底部
                                    setTimeout(() => {
                                      document.dispatchEvent(
                                        new CustomEvent('cosmo-claw-scroll-bottom')
                                      )
                                    }, 100)
                                    // Section 4: 关键发现（loading后展示 + 打印机效果）
                                    setTimeout(() => {
                                      this.revealSection(
                                        `chain-revenue-section-4-${reportId}`,
                                        'block'
                                      )
                                      setTimeout(() => {
                                        const s4Loader = this._findVisibleEl(
                                          `chain-revenue-s4-loading-${reportId}`
                                        )
                                        const s4Content = this._findVisibleEl(
                                          `chain-revenue-s4-content-${reportId}`
                                        )
                                        if (s4Loader) s4Loader.style.display = 'none'
                                        if (s4Content) s4Content.style.display = 'block'
                                        const findingText = `• 同比增量最大：${
                                          topLifter.name
                                        }（${formatNumber(topLifter.yoy)} 万元，${
                                          topLifter.yoyRate
                                        }%）\n• 同比下降最显著：${
                                          bottomLagger.name
                                        }（${formatNumber(bottomLagger.yoy)} 万元，${
                                          bottomLagger.yoyRate
                                        }%）\n• 收入增长来源：${
                                          chainRows.filter((g) => g.yoy > 0).length
                                        } 个链群实现同比增长\n• ${
                                          yoyChange >= 0
                                            ? '整体收入较上年同期增长，增长质量需结合毛利率等盈利指标综合评估'
                                            : '整体收入较上年同期下降，需重点关注负增长链群的经营诊断'
                                        }`
                                        setTimeout(() => {
                                          this.typeWriterEffect(
                                            `chain-revenue-finding-text-${reportId}`,
                                            findingText,
                                            () => {
                                              // Section 5: 推荐按钮（内容输出完毕后展示）
                                              setTimeout(() => {
                                                this.revealSection(
                                                  `chain-revenue-section-5-${reportId}`,
                                                  'block'
                                                )
                                                // 推荐按钮显示后再次滚动到底部
                                                setTimeout(() => {
                                                  document.dispatchEvent(
                                                    new CustomEvent(
                                                      'cosmo-claw-scroll-bottom'
                                                    )
                                                  )
                                                }, 100)
                                              }, 200)
                                            }
                                          )
                                        }, 280)
                                      }, 600)
                                    }, 200)
                                  }
                                }, 600)
                              }
                            )
                          }, 280)
                        }, 800)
                      }, 280)
                    }
                  )
                }
              )
            }
          )
        }, 200)
      }, 200)
    },
    triggerChainPerformanceBreakdown(staticMsgId) {
      const uniqueSuffix = staticMsgId ? '_' + String(staticMsgId).slice(-6) : '_' + Date.now()
      const reportId = 'chain-perf-' + uniqueSuffix
      const CHAIN_GROUPS = [
        { name: '智能制造', actual: 15442.3684, target: 24478.3871, owner: '谢海琴' },
        { name: '智能产线', actual: 20327.9464, target: 26390.9677, owner: '丁斌' },
        { name: '机器视觉', actual: 1176.753, target: 4302.9032, owner: '王暾' },
        { name: '工赋平台', actual: 4228.595, target: 4744.8387, owner: '刁兴全' },
        { name: '化工行业', actual: 2142.1309, target: 5668.7097, owner: '张乐交' },
        { name: '智慧能源', actual: 18662.8261, target: 25641.9355, owner: '邵凯' },
        { name: '碳索能源', actual: 37855.5928, target: 40550.3871, owner: '张智权' },
        {
          name: 'AIOT解决方案',
          actual: 270398.3215,
          target: 267096.7742,
          owner: '侯正领'
        }
      ]
      const SUMMARY = {
        totalActual: 368558.696,
        totalTarget: 397858.7742,
        totalGap: 29300.0782,
        totalRate: 92.6356,
        achievedCount: 1,
        gapCount: 7
      }
      /* eslint-disable-next-line no-unused-vars */
      const totalActual = SUMMARY.totalActual
      /* eslint-disable-next-line no-unused-vars */
      const totalTarget = SUMMARY.totalTarget
      const totalGap = -SUMMARY.totalGap
      const fmt = (v) => Number(v).toLocaleString('en-US')
      const formatNumber = (v) => (v >= 0 ? '+' : '') + Number(v).toLocaleString('en-US')

      const chainRows = CHAIN_GROUPS.map((g) => {
        const gap = g.actual - g.target
        const rate = ((g.actual / g.target) * 100).toFixed(1)
        return { ...g, gap, rate }
      })

      const positiveChains = chainRows.filter((g) => g.gap >= 0)
      const negativeChains = chainRows.filter((g) => g.gap < 0)
      const topPerformance = chainRows.reduce(
        (best, g) => (parseFloat(g.rate) > parseFloat(best?.rate || '0') ? g : best),
        chainRows[0]
      )

      const section2Id = `chain-perf-summary-${reportId}`

      const body = `
        <div id="chain-perf-report-${reportId}" style="margin-top:2px;display:flex;flex-direction:column;gap:10px;">
          <style>@keyframes chain-perf-spin-${reportId}{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}</style>
          <div id="chain-perf-section-0-${reportId}" style="padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(74,95,243,0.08),rgba(14,165,233,0.05));border:1px solid rgba(74,95,243,0.16);display:none;">
            <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4A5FF3" stroke-width="2"><path d="M20 7h-9M14 17H5m11 0a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2m9-9a2 2 0 0 1 2 2v3.5a2.5 2.5 0 0 1-2.5 2.5H14"/></svg>
              <span id="chain-perf-s0-label-${reportId}" style="font-size:12px;font-weight:600;color:#4A5FF3;"></span>
            </div>
            <div id="chain-perf-s0-title-${reportId}" style="font-size:14px;font-weight:700;color:#1f2937;margin-bottom:4px;"></div>
            <div id="chain-perf-s0-date-${reportId}" style="font-size:11px;color:#94a3b8;"></div>
          </div>

          <div id="chain-perf-section-1-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div id="chain-perf-s1-loading-${reportId}" style="display:flex;height:60px;align-items:center;justify-content:center;gap:10px;">
              <div style="width:20px;height:20px;border:3px solid #e8ecf0;border-top:3px solid #4A5FF3;border-radius:50%;animation:chain-perf-spin-${reportId} 0.8s linear infinite;"></div>
              <span style="font-size:11px;color:#94a3b8;">正在加载经营数据...</span>
            </div>
            <div id="chain-perf-s1-content-${reportId}" style="display:none;">
              <div style="display:flex;gap:10px;">
                <div style="flex:1;padding:12px;border-radius:10px;background:#f0fdf4;text-align:center;">
                  <div style="font-size:18px;font-weight:800;color:#0aa66a;">368558.7</div>
                  <div style="font-size:10px;color:#64748b;margin-top:2px;">上半年实际收入</div>
                </div>
                <div style="flex:1;padding:12px;border-radius:10px;background:#f8fafc;text-align:center;">
                  <div style="font-size:18px;font-weight:800;color:#1f2937;">397858.8</div>
                  <div style="font-size:10px;color:#64748b;margin-top:2px;">上半年目标收入</div>
                </div>
                <div style="flex:1;padding:12px;border-radius:10px;background:${
  totalGap >= 0 ? '#f0fdf4' : '#fef2f2'
};text-align:center;">
                  <div style="font-size:18px;font-weight:800;color:${
  totalGap >= 0 ? '#0aa66a' : '#e54b3d'
};">29,300.1</div>
                  <div style="font-size:10px;color:#64748b;margin-top:2px;">目标差额</div>
                </div>
              </div>
            </div>
          </div>

          <div id="chain-perf-section-2-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div id="${section2Id}" style="padding:12px 14px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;font-size:12px;color:#475569;line-height:1.8;min-height:44px;">
              <b style="color:#1f2937;">业绩总览：</b><span id="${section2Id}-span"></span>
            </div>
          </div>

          <div id="chain-perf-section-3-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div style="overflow-x:auto;">
              <table style="width:100%;border-collapse:collapse;font-size:12px;">
                <thead>
                  <tr style="background:#f8fafc;">
                    <th style="padding:8px 10px;text-align:left;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">链群</th>
                    <th style="padding:8px 10px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">本期收入</th>
                    <th style="padding:8px 10px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">目标收入</th>
                    <th style="padding:8px 10px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">差额</th>
                    <th style="padding:8px 10px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">完成率</th>
                    <th style="padding:8px 10px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">负责人</th>
                  </tr>
                </thead>
                <tbody id="chain-perf-table-body-${reportId}">
                  <tr><td colspan="6" style="padding:24px;text-align:center;">
                    <div style="width:24px;height:24px;border:3px solid #e8ecf0;border-top:3px solid #4A5FF3;border-radius:50%;animation:chain-perf-spin-${reportId} 0.8s linear infinite;margin:0 auto 8px;"></div>
                    <span style="font-size:11px;color:#94a3b8;">正在加载链群数据...</span>
                  </td></tr>
                </tbody>
              </table>
            </div>
          </div>

          <div id="chain-perf-section-4-${reportId}" style="padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(74,95,243,0.05),rgba(14,165,233,0.03));border:1px solid rgba(74,95,243,0.12);display:none;">
            <div id="chain-perf-s4-loading-${reportId}" style="display:flex;height:60px;align-items:center;justify-content:center;gap:10px;">
              <div style="width:16px;height:16px;border:2px solid #e8ecf0;border-top:2px solid #4A5FF3;border-radius:50%;animation:chain-perf-spin-${reportId} 0.8s linear infinite;"></div>
              <span style="font-size:11px;color:#94a3b8;">正在生成关键发现...</span>
            </div>
            <div id="chain-perf-s4-content-${reportId}" style="display:none;">
              <div id="chain-perf-finding-${reportId}" style="font-size:11px;color:#475569;line-height:1.7;">
                <b style="color:#4A5FF3;">关键发现</b><br>
                <span id="chain-perf-finding-text-${reportId}"></span>
              </div>
            </div>
          </div>

          <div id="chain-perf-section-5-${reportId}" style="display:none;">
            <div style="display:flex;flex-wrap:wrap;gap:8px;">
              <button type="button" onclick="if(window.triggerIndustryCompetitiveness){window.triggerIndustryCompetitiveness();}" style="padding:7px 12px;border-radius:8px;background:linear-gradient(135deg,rgba(245,158,11,0.08),rgba(245,158,11,0.03));border:1px solid rgba(245,158,11,0.18);font-size:11px;color:#d97706;cursor:pointer;transition:all 0.2s ease;display:flex;align-items:center;gap:6px;" onmouseover="this.style.background='linear-gradient(135deg,rgba(245,158,11,0.14),rgba(245,158,11,0.06))';this.style.borderColor='rgba(245,158,11,0.28)'" onmouseout="this.style.background='linear-gradient(135deg,rgba(245,158,11,0.08),rgba(245,158,11,0.03))';this.style.borderColor='rgba(245,158,11,0.18)'">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"><path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg>
                <span>深度分析：行业解决方案竞争力不足</span>
              </button>
              <button type="button" onclick="if(window.triggerIndustryCompetitiveness){window.triggerIndustryCompetitiveness();}" style="padding:7px 12px;border-radius:8px;background:linear-gradient(135deg,rgba(245,158,11,0.08),rgba(245,158,11,0.03));border:1px solid rgba(245,158,11,0.18);font-size:11px;color:#d97706;cursor:pointer;transition:all 0.2s ease;display:flex;align-items:center;gap:6px;" onmouseover="this.style.background='linear-gradient(135deg,rgba(245,158,11,0.14),rgba(245,158,11,0.06))';this.style.borderColor='rgba(245,158,11,0.28)'" onmouseout="this.style.background='linear-gradient(135deg,rgba(245,158,11,0.08),rgba(245,158,11,0.03))';this.style.borderColor='rgba(245,158,11,0.18)'">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"><path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg>
                <span>深度分析：客户结构不好</span>
              </button>
              <button type="button" onclick="if(window.triggerIndustryCompetitiveness){window.triggerIndustryCompetitiveness();}" style="padding:7px 12px;border-radius:8px;background:linear-gradient(135deg,rgba(245,158,11,0.08),rgba(245,158,11,0.03));border:1px solid rgba(245,158,11,0.18);font-size:11px;color:#d97706;cursor:pointer;transition:all 0.2s ease;display:flex;align-items:center;gap:6px;" onmouseover="this.style.background='linear-gradient(135deg,rgba(245,158,11,0.14),rgba(245,158,11,0.06))';this.style.borderColor='rgba(245,158,11,0.28)'" onmouseout="this.style.background='linear-gradient(135deg,rgba(245,158,11,0.08),rgba(245,158,11,0.03))';this.style.borderColor='rgba(245,158,11,0.18)'">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"><path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg>
                <span>深度分析：全球布局能力没有建立起来</span>
              </button>
            </div>
          </div>
        </div>
        <style>@keyframes chain-perf-spin-${reportId}{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}</style>`

      const title = '业绩解构分析'
      const summaryText = `上半年八个业务链群实际收入 ${fmt(
        SUMMARY.totalActual
      )} 万元，目标收入 ${fmt(
        SUMMARY.totalTarget
      )} 万元，整体达成率 ${SUMMARY.totalRate.toFixed(1)}%，目标差额 +${fmt(
        SUMMARY.totalGap
      )} 万元。${SUMMARY.achievedCount} 个链群超额达成，${
        SUMMARY.gapCount
      } 个链群存在缺口。`
      const findingText = `• 目标达成率最高：${topPerformance.name}（${
        topPerformance.rate
      }%）\n• 缺口最大链群：${negativeChains.length ? negativeChains[0].name : '无'}（${
        negativeChains.length ? formatNumber(negativeChains[0].gap) : '0'
      } 万元）\n• 超额贡献链群：${SUMMARY.achievedCount} 个，合计正向拉动 ${formatNumber(
        positiveChains.reduce((s, g) => s + g.gap, 0)
      )} 万元\n• ${
        SUMMARY.achievedCount >= 5
          ? '整体达成较好，多数链群超额完成目标'
          : '部分链群存在缺口，需重点关注尾部链群的经营改善'
      }`

      if (staticMsgId) {
        this.$store.commit('cosmoClaw/UPDATE_MESSAGE_CONTENT_BY_ID', {
          id: staticMsgId,
          content: body,
          richHtml: true
        })
        var s = this
        return new Promise(function (resolve) {
          s.$nextTick(function () {
            for (var si = 0; si <= 5; si++) {
              var el = s._findVisibleEl('chain-perf-section-' + si + '-' + reportId)
              if (el) el.style.display = 'block'
            }
            var t = function (id, txt) {
              var e = s._findVisibleEl(id)
              if (e) e.textContent = txt
            }
            t('chain-perf-s0-label-' + reportId, '业务链群业绩解构')
            t('chain-perf-s0-title-' + reportId, '卡奥斯上半年目标达成解构')
            t('chain-perf-s0-date-' + reportId, '2026 年上半年 · 单位：万元')
            var l1 = s._findVisibleEl('chain-perf-s1-loading-' + reportId)
            var c1 = s._findVisibleEl('chain-perf-s1-content-' + reportId)
            if (l1) l1.style.display = 'none'
            if (c1) c1.style.display = 'block'
            var sp = s._findVisibleEl('chain-perf-summary-' + reportId + '-span')
            if (sp) sp.textContent = summaryText
            var tb = s._findVisibleEl('chain-perf-table-body-' + reportId)
            if (tb) {
              var rows = chainRows
                .map(function (g) {
                  return (
                    '<tr><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;font-weight:600;">' +
                    g.name +
                    '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#475569;text-align:right;">' +
                    fmt(g.actual) +
                    '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#475569;text-align:right;">' +
                    fmt(g.target) +
                    '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:' +
                    (g.gap >= 0 ? '#0aa66a' : '#e54b3d') +
                    ';">' +
                    formatNumber(g.gap) +
                    '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:' +
                    (parseFloat(g.rate) >= 100 ? '#0aa66a' : '#d98213') +
                    ';">' +
                    g.rate +
                    '%</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#94a3b8;text-align:right;">' +
                    g.owner +
                    '</td></tr>'
                  )
                })
                .join('')
              var tr =
                '<tr style="font-weight:700;background:#f8fafc;"><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;">合计</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;text-align:right;">' +
                fmt(SUMMARY.totalActual) +
                '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;text-align:right;">' +
                fmt(SUMMARY.totalTarget) +
                '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:#e54b3d;">' +
                '+' +
                fmt(SUMMARY.totalGap) +
                '</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:#1f2937;">' +
                SUMMARY.totalRate.toFixed(1) +
                '%</td><td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#94a3b8;text-align:right;"></td></tr>'
              tb.innerHTML = rows + tr
            }
            var l4 = s._findVisibleEl('chain-perf-s4-loading-' + reportId)
            var c4 = s._findVisibleEl('chain-perf-s4-content-' + reportId)
            if (l4) l4.style.display = 'none'
            if (c4) c4.style.display = 'block'
            var ftext =
              '• 目标达成率最高：' +
              topPerformance.name +
              '（' +
              topPerformance.rate +
              '%）\\n• 缺口最大链群：' +
              (negativeChains.length ? negativeChains[0].name : '无') +
              '（' +
              (negativeChains.length ? formatNumber(negativeChains[0].gap) : '0') +
              ' 万元）\\n• 超额贡献链群：' +
              SUMMARY.achievedCount +
              ' 个，合计正向拉动 ' +
              formatNumber(
                positiveChains.reduce(function (s, g) {
                  return s + g.gap
                }, 0)
              ) +
              ' 万元\\n• ' +
              (SUMMARY.achievedCount >= 5
                ? '整体达成较好，多数链群超额完成目标'
                : '部分链群存在缺口，需重点关注尾部链群的经营改善')
            t('chain-perf-finding-text-' + reportId, ftext)
            resolve()
          })
        })
      }
      this.addSmartFlowHistory(title)
      this.appendLocalMessage('assistant', body, true)
      this.persistMockMessage('assistant', '[mock:chain-perf]')

      // 串行揭示：全部文字打印机效果，按顺序逐渐展示
      setTimeout(() => {
        // Section 0: 流式输出标题
        this.revealSection(`chain-perf-section-0-${reportId}`, 'block')
        setTimeout(() => {
          this.typeWriterEffect(
            `chain-perf-s0-label-${reportId}`,
            '业务链群业绩解构',
            () => {
              this.typeWriterEffect(
                `chain-perf-s0-title-${reportId}`,
                '卡奥斯上半年目标达成解构',
                () => {
                  this.typeWriterEffect(
                    `chain-perf-s0-date-${reportId}`,
                    '2026 年上半年 · 单位：万元',
                    () => {
                      // Section 0 完毕 → Section 1（统计卡片，loading后展示）
                      this.revealSection(`chain-perf-section-1-${reportId}`, 'block')
                      setTimeout(() => {
                        const loader = this._findVisibleEl(
                          `chain-perf-s1-loading-${reportId}`
                        )
                        const content = this._findVisibleEl(
                          `chain-perf-s1-content-${reportId}`
                        )
                        if (loader) loader.style.display = 'none'
                        if (content) content.style.display = 'block'
                        // Section 1 完毕 → Section 2（业绩总览，打印机效果）
                        setTimeout(() => {
                          this.revealSection(`chain-perf-section-2-${reportId}`, 'block')
                          setTimeout(() => {
                            this.typeWriterEffect(
                              `${section2Id}-span`,
                              summaryText,
                              () => {
                                // Section 2 完毕 → Section 3（表格，loading后逐行加载）
                                this.revealSection(
                                  `chain-perf-section-3-${reportId}`,
                                  'block'
                                )
                                setTimeout(() => {
                                  const tbody = this._findVisibleEl(
                                    `chain-perf-table-body-${reportId}`
                                  )
                                  if (tbody) {
                                    // 一次性展示所有表格内容（不需要流式输出）
                                    const rows = chainRows
                                      .map(
                                        (g) => `
                              <tr>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;font-weight:600;">${
  g.name
}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#475569;text-align:right;">${fmt(
    g.actual
  )}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#475569;text-align:right;">${fmt(
    g.target
  )}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:${
  g.gap >= 0 ? '#0aa66a' : '#e54b3d'
};">${formatNumber(g.gap)}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:${
  parseFloat(g.rate) >= 100 ? '#0aa66a' : '#d98213'
};">${g.rate}%</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#94a3b8;text-align:right;">${
  g.owner
}</td>
                              </tr>`
                                      )
                                      .join('')
                                    // 添加合计行
                                    const totalRow = `
                              <tr style="font-weight:700;background:#f8fafc;">
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;">合计</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;text-align:right;">${fmt(
    SUMMARY.totalActual
  )}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#1f2937;text-align:right;">${fmt(
    SUMMARY.totalTarget
  )}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:#e54b3d;">+${fmt(
    SUMMARY.totalGap
  )}</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;text-align:right;color:#1f2937;">${SUMMARY.totalRate.toFixed(
    1
  )}%</td>
                                <td style="padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:12px;color:#94a3b8;text-align:right;"></td>
                              </tr>`
                                    tbody.innerHTML = rows + totalRow
                                    // 表格加载完成，滚动到聊天框底部
                                    setTimeout(() => {
                                      document.dispatchEvent(
                                        new CustomEvent('cosmo-claw-scroll-bottom')
                                      )
                                    }, 100)
                                    // Section 4: 关键发现（loading后展示 + 打印机效果）
                                    setTimeout(() => {
                                      this.revealSection(
                                        `chain-perf-section-4-${reportId}`,
                                        'block'
                                      )
                                      setTimeout(() => {
                                        const s4Loader = this._findVisibleEl(
                                          `chain-perf-s4-loading-${reportId}`
                                        )
                                        const s4Content = this._findVisibleEl(
                                          `chain-perf-s4-content-${reportId}`
                                        )
                                        if (s4Loader) s4Loader.style.display = 'none'
                                        if (s4Content) s4Content.style.display = 'block'
                                        setTimeout(() => {
                                          this.typeWriterEffect(
                                            `chain-perf-finding-text-${reportId}`,
                                            findingText,
                                            () => {
                                              // Section 5: 推荐按钮
                                              setTimeout(() => {
                                                this.revealSection(
                                                  `chain-perf-section-5-${reportId}`,
                                                  'block'
                                                )
                                                // 推荐按钮显示后再次滚动到底部
                                                setTimeout(() => {
                                                  document.dispatchEvent(
                                                    new CustomEvent(
                                                      'cosmo-claw-scroll-bottom'
                                                    )
                                                  )
                                                }, 100)
                                              }, 200)
                                            }
                                          )
                                        }, 280)
                                      }, 600)
                                    }, 200)
                                  }
                                }, 600)
                              }
                            )
                          }, 280)
                        }, 800)
                      }, 280)
                    }
                  )
                }
              )
            }
          )
        }, 200)
      }, 200)
    },
    triggerIndustryCompetitiveness(staticMsgId) {
      // 先发送用户消息
      if (!staticMsgId) {
        this.persistMockMessage('user', '深度分析：行业解决方案竞争力不足')
        this.forceScrollToBottom()
      }

      const uniqueSuffix = staticMsgId ? '_' + String(staticMsgId).slice(-6) : '_' + Date.now()
      const reportId = 'industry-comp-request-' + uniqueSuffix
      const textId = `industry-comp-text-${reportId}`
      const buttons1Id = `industry-comp-buttons1-${reportId}`
      const buttons2Id = `industry-comp-buttons2-${reportId}`

      const cardHtml = `
        <div id="industry-comp-request-${reportId}" style="margin-top:2px;">
          <div style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
            <div style="font-size:12px;color:#475569;line-height:1.8;margin-bottom:16px;">
              <span id="${textId}"></span>
            </div>
            <div id="${buttons1Id}" style="display:none;flex;gap:10px;margin-bottom:16px;">
              <button type="button" onclick="if(window.openIndustryReport){window.openIndustryReport();}" style="padding:8px 14px;border-radius:8px;background:#f8fafc;border:1px solid #e8ecf0;font-size:11px;color:#475569;cursor:pointer;transition:all 0.2s ease;display:flex;align-items:center;gap:6px;" onmouseover="this.style.background='#f1f5f9';this.style.borderColor='#d1d5db'" onmouseout="this.style.background='#f8fafc';this.style.borderColor='#e8ecf0'">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#4A5FF3" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>
                <span>五大行业经营情况</span>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>
              </button>
              <button type="button" onclick="if(window.openChainReport){window.openChainReport();}" style="padding:8px 14px;border-radius:8px;background:#f8fafc;border:1px solid #e8ecf0;font-size:11px;color:#475569;cursor:pointer;transition:all 0.2s ease;display:flex;align-items:center;gap:6px;" onmouseover="this.style.background='#f1f5f9';this.style.borderColor='#d1d5db'" onmouseout="this.style.background='#f8fafc';this.style.borderColor='#e8ecf0'">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#4A5FF3" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></svg>
                <span>业务链群经营情况</span>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>
              </button>
            </div>
            <div id="${buttons2Id}" style="display:none;flex;justify-content:flex-end;gap:10px;">
              <button type="button" onclick="if(window.triggerIndustryCompetitivenessConfirm){window.triggerIndustryCompetitivenessConfirm();}" style="padding:8px 16px;border-radius:8px;background:#0aa66a;border:none;font-size:12px;color:#ffffff;cursor:pointer;transition:all 0.2s ease;font-weight:600;" onmouseover="this.style.background='#088a56'" onmouseout="this.style.background='#0aa66a'">
                同意
              </button>
              <button type="button" style="padding:8px 16px;border-radius:8px;background:#f8fafc;border:1px solid #e8ecf0;font-size:12px;color:#6b7280;cursor:pointer;transition:all 0.2s ease;" onmouseover="this.style.background='#f1f5f9';this.style.borderColor='#d1d5db'" onmouseout="this.style.background='#f8fafc';this.style.borderColor='#e8ecf0'">
                拒绝
              </button>
            </div>
          </div>
        </div>
      `
      if (staticMsgId) {
        this.$store.commit('cosmoClaw/UPDATE_MESSAGE_CONTENT_BY_ID', {
          id: staticMsgId,
          content: cardHtml,
          richHtml: true
        })
        var self = this
        return new Promise(function (resolve) {
          self.$nextTick(function () {
            const textEl = self._findVisibleEl(textId)
            const btn1 = self._findVisibleEl(buttons1Id)
            const btn2 = self._findVisibleEl(buttons2Id)
            if (textEl) {
              textEl.textContent =
                '\u4efb\u52a1\u5df2\u6536\u5230\uff0c\u56f4\u7ed5\u884c\u4e1a\u89e3\u51b3\u65b9\u6848\u7ade\u4e89\u529b\u4e0d\u8db3\uff0c\u6211\u4f1a\u5148\u6821\u9a8c\u4e94\u5927\u884c\u4e1a\u666f\u6c14\u5ea6\u3001\u884c\u4e1a\u89e3\u51b3\u65b9\u6848\u7ade\u4e89\u529b\u53ca\u4e1a\u52a1\u94fe\u7fa4\u7ecf\u8425\u8868\u73b0\uff0c\u5c06\u4f7f\u7528\u4ee5\u4e0b\u62a5\u8868\u8fdb\u884c\u6570\u636e\u5206\u6790\uff1a'
            }
            if (btn1) btn1.style.display = 'flex'
            if (btn2) btn2.style.display = 'flex'
            resolve()
          })
        })
      }
      this.appendLocalMessage('assistant', cardHtml, true)
      this.persistMockMessage('assistant', '[mock:ceo-industry-competitiveness]')

      // 串行揭示：打印机效果 → 报表按钮 → 同意/拒绝按钮
      const contentText =
        '任务已收到，围绕行业解决方案竞争力不足，我会先校验五大行业景气度、行业解决方案竞争力及业务链群经营表现，将使用以下报表进行数据分析：'
      setTimeout(() => {
        this.typeWriterEffect(textId, contentText, () => {
          // 文字打印机效果完成，显示报表按钮
          setTimeout(() => {
            const btn1 = this._findVisibleEl(buttons1Id)
            if (btn1) btn1.style.display = 'flex'
            // 报表按钮显示后，显示同意/拒绝按钮
            setTimeout(() => {
              const btn2 = this._findVisibleEl(buttons2Id)
              if (btn2) btn2.style.display = 'flex'
              // 滚动到聊天框底部
              setTimeout(() => {
                document.dispatchEvent(new CustomEvent('cosmo-claw-scroll-bottom'))
              }, 100)
            }, 200)
          }, 200)
        })
      }, 200)
    },
    triggerIndustryCompetitivenessConfirm(staticMsgId) {
      // 发送用户消息
      if (!staticMsgId) {
        this.persistMockMessage('user', '行业解决方案竞争力不足分析')
        this.forceScrollToBottom()
      }
      if (staticMsgId) {
        var self = this
        return new Promise(function (resolve) {
          self.renderIndustryCompetitivenessCard(staticMsgId)
          // Wait for DOM update after renderIndustryCompetitivenessCard updates the message
          self.$nextTick(function () {
            resolve()
          })
        })
      }

      const thinkingId = 'industry-comp-thinking-' + Date.now()
      const thinkingSteps = [
        '正在校验五大行业景气度与业务链群经营表现...',
        '正在对比各行业达成率与竞争力指标...',
        '正在分析行业解决方案的优势与短板...',
        '正在识别丢单根因与经营风险...',
        '正在生成行业竞争力分析结论与建议...'
      ]
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          '行业解决方案竞争力不足分析',
          '正在基于五大行业经营报表与业务链群经营数据，诊断行业解决方案竞争力问题...',
          thinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            this.renderIndustryCompetitivenessCard()
          }, 500)
        }
      }, 1500)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    renderIndustryCompetitivenessCard(staticMsgId) {
      const uniqueSuffix = staticMsgId ? '_' + String(staticMsgId).slice(-6) : '_' + Date.now()
      const reportId = 'industry-comp-' + uniqueSuffix
      const section1Id = `comp-summary-${reportId}`

      const cardHtml = `
        <div id="industry-comp-report-${reportId}" style="margin-top:2px;display:flex;flex-direction:column;gap:10px;">
          <div id="industry-comp-section-0-${reportId}" style="padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(245,158,11,0.06),rgba(217,119,6,0.03));border:1px solid rgba(245,158,11,0.15);display:none;">
            <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"><path d="M20 7h-9M14 17H5m11 0a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2m9-9a2 2 0 0 1 2 2v3.5a2.5 2.5 0 0 1-2.5 2.5H14"/></svg>
              <span id="comp-label-${reportId}" style="font-size:12px;font-weight:600;color:#d97706;"></span>
            </div>
            <div id="comp-title-${reportId}" style="font-size:14px;font-weight:700;color:#1f2937;margin-bottom:4px;"></div>
            <div id="comp-date-${reportId}" style="font-size:11px;color:#94a3b8;"></div>
          </div>

          <div id="industry-comp-section-1-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div style="display:flex;align-items:flex-start;gap:10px;">
              <div style="width:32px;height:32px;border-radius:8px;background:#fef3c7;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
              </div>
              <div id="${section1Id}" style="font-size:12px;color:#475569;line-height:1.8;min-height:44px;">
                <strong id="comp-headline-${reportId}" style="font-weight:700;color:#1f2937;"></strong>
                <span id="${section1Id}-span" style="display:block;margin-top:4px;"></span>
              </div>
            </div>
          </div>

          <div id="industry-comp-section-2-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div id="comp-s2-loading-${reportId}" style="display:flex;height:80px;align-items:center;justify-content:center;gap:10px;">
              <div style="width:16px;height:16px;border:2px solid #e8ecf0;border-top:2px solid #d97706;border-radius:50%;animation:chain-perf-spin-${reportId} 0.8s linear infinite;"></div>
              <span style="font-size:11px;color:#94a3b8;">正在分析优势与短板...</span>
            </div>
            <div id="comp-s2-content-${reportId}" style="display:none;">
              <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
                <div style="padding:12px 14px;border-radius:10px;background:#f0fdf4;border:1px solid rgba(10,166,106,0.12);font-size:11px;color:#475569;line-height:1.7;">
                  <b style="color:#0aa66a;">已有优势</b><br><span id="comp-adv-${reportId}"></span>
                </div>
                <div style="padding:12px 14px;border-radius:10px;background:#fef2f2;border:1px solid rgba(229,75,61,0.12);font-size:11px;color:#475569;line-height:1.7;">
                  <b style="color:#e54b3d;">主要短板</b><br><span id="comp-short-${reportId}"></span>
                </div>
              </div>
            </div>
          </div>

          <div id="industry-comp-section-3-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div id="comp-s3-loading-${reportId}" style="display:flex;height:120px;align-items:center;justify-content:center;gap:10px;">
              <div style="width:16px;height:16px;border:2px solid #e8ecf0;border-top:2px solid #d97706;border-radius:50%;animation:chain-perf-spin-${reportId} 0.8s linear infinite;"></div>
              <span style="font-size:11px;color:#94a3b8;">正在分析经营风险...</span>
            </div>
            <div id="comp-s3-content-${reportId}" style="display:none;">
              <div style="font-size:12px;font-weight:600;color:#1f2937;margin-bottom:10px;">五大行业经营对标及丢单分析</div>
              <div style="overflow-x:auto;">
                <table style="width:100%;border-collapse:separate;border-spacing:0;font-size:11px;">
                  <thead>
                    <tr>
                      <th style="padding:6px 8px;color:#fff;background:#0d5fac;font-weight:800;text-align:center;border-right:1px solid rgba(148,163,184,.28);white-space:nowrap;">五大行业</th>
                      <th style="padding:6px 8px;color:#fff;background:#0d5fac;font-weight:800;text-align:center;border-right:1px solid rgba(148,163,184,.28);white-space:nowrap;">对应链群</th>
                      <th style="padding:6px 8px;color:#fff;background:#0d5fac;font-weight:800;text-align:center;border-right:1px solid rgba(148,163,184,.28);white-space:nowrap;">签约额</th>
                      <th style="padding:6px 8px;color:#fff;background:#0d5fac;font-weight:800;text-align:center;border-right:1px solid rgba(148,163,184,.28);white-space:nowrap;">签约完成率</th>
                      <th style="padding:6px 8px;color:#fff;background:#0d5fac;font-weight:800;text-align:center;border-right:1px solid rgba(148,163,184,.28);white-space:nowrap;">丢单金额</th>
                      <th style="padding:6px 8px;color:#fff;background:#0d5fac;font-weight:800;text-align:center;border-right:1px solid rgba(148,163,184,.28);white-space:nowrap;">占比</th>
                      <th style="padding:6px 8px;color:#fff;background:#0d5fac;font-weight:800;text-align:center;white-space:nowrap;">评价</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);font-weight:800;text-align:left;">家电行业</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:center;font-size:10px;color:#64748b;">咨询链群</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:right;">9,733</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:center;font-weight:800;color:#e54b3d;">79.02%</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:right;">18,819</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:right;">55.43%</td><td style="padding:6px 8px;border-bottom:1px solid rgba(148,163,184,.28);text-align:center;color:#e54b3d;font-weight:800;">需关注</td></tr>
                    <tr><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);font-weight:800;text-align:left;">汽车行业</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:center;font-size:10px;color:#64748b;">汽车汽配</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:right;">3,069</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:center;font-weight:800;color:#e54b3d;">70.54%</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:right;">16,519</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:right;">58.72%</td><td style="padding:6px 8px;border-bottom:1px solid rgba(148,163,184,.28);text-align:center;color:#e54b3d;font-weight:800;">需关注</td></tr>
                    <tr><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);font-weight:800;text-align:left;">泛半导体行业</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:center;font-size:10px;color:#64748b;">碳索能源</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:right;">73,899</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:center;font-weight:800;color:#0aa66a;">128.52%</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:right;">16,722</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:right;">21.26%</td><td style="padding:6px 8px;border-bottom:1px solid rgba(148,163,184,.28);text-align:center;color:#0aa66a;font-weight:800;">达标</td></tr>
                    <tr><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);font-weight:800;text-align:left;">机械装备行业</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:center;font-size:10px;color:#64748b;">智能制造新</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:right;">9,704</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:center;font-weight:800;color:#e54b3d;">66.59%</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:right;">39,861</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);border-bottom:1px solid rgba(148,163,184,.28);text-align:right;">83.26%</td><td style="padding:6px 8px;border-bottom:1px solid rgba(148,163,184,.28);text-align:center;color:#e54b3d;font-weight:800;">需关注</td></tr>
                    <tr><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);font-weight:800;text-align:left;">流程行业</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);text-align:center;font-size:10px;color:#64748b;">化工行业</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);text-align:right;">1,528</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);text-align:center;font-weight:800;color:#e54b3d;">21.33%</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);text-align:right;">11,835</td><td style="padding:6px 8px;border-right:1px solid rgba(148,163,184,.28);text-align:right;">82.54%</td><td style="padding:6px 8px;text-align:center;color:#e54b3d;font-weight:800;">风险</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div id="industry-comp-section-4-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div id="comp-sug-section-title-${reportId}" style="font-size:12px;font-weight:600;color:#1f2937;margin-bottom:10px;"></div>
            <div style="display:flex;flex-direction:column;gap:10px;">
              <div id="comp-sug-card-${reportId}-0" style="display:none;align-items:flex-start;gap:10px;padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;">
                <div style="width:28px;height:28px;border-radius:8px;background:#fef3c7;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:14px;">&#11088;</div>
                <div style="flex:1;"><div id="comp-sug-title-${reportId}-0" style="font-size:12px;font-weight:600;color:#1f2937;"></div><div id="comp-sug-desc-${reportId}-0" style="font-size:11px;color:#6b7280;margin-top:2px;"></div></div>
                <span style="padding:2px 8px;border-radius:999px;background:#e8f5e9;color:#2e7d32;font-size:10px;font-weight:600;flex-shrink:0;">30 天</span>
              </div>
              <div id="comp-sug-card-${reportId}-1" style="display:none;align-items:flex-start;gap:10px;padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;">
                <div style="width:28px;height:28px;border-radius:8px;background:#dbe6ff;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:14px;">&#128202;</div>
                <div style="flex:1;"><div id="comp-sug-title-${reportId}-1" style="font-size:12px;font-weight:600;color:#1f2937;"></div><div id="comp-sug-desc-${reportId}-1" style="font-size:11px;color:#6b7280;margin-top:2px;"></div></div>
                <span style="padding:2px 8px;border-radius:999px;background:#fff7ed;color:#d98213;font-size:10px;font-weight:600;flex-shrink:0;">60 天</span>
              </div>
              <div id="comp-sug-card-${reportId}-2" style="display:none;align-items:flex-start;gap:10px;padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;">
                <div style="width:28px;height:28px;border-radius:8px;background:#fef2f2;display:flex;align-items:center;justify-content:center;flex-shrink:0;font-size:14px;">&#128260;</div>
                <div style="flex:1;"><div id="comp-sug-title-${reportId}-2" style="font-size:12px;font-weight:600;color:#1f2937;"></div><div id="comp-sug-desc-${reportId}-2" style="font-size:11px;color:#6b7280;margin-top:2px;"></div></div>
                <span style="padding:2px 8px;border-radius:999px;background:#e8f5e9;color:#2e7d32;font-size:10px;font-weight:600;flex-shrink:0;">周度</span>
              </div>
            </div>
          </div>
        </div>
      `

      // 串行打字机效果：从上到下流式输出
      const compSugTexts = [
        {
          title: '资源向强势行业聚焦',
          desc:
            '机械装备、汽车优先沉淀标准方案包、标杆案例与交付报价边界，提升复制效率。'
        },
        {
          title: '补齐价值量化工具',
          desc:
            '家电、流程行业统一建设投资回报测算模板，将节能、提效与停机损失改善转为客户财务收益。'
        },
        {
          title: '建立丢单闭环机制',
          desc:
            '按预算、价格、方案、交付四类原因复盘重点丢单，形成竞品对标和投标策略迭代。'
        }
      ]
      const summaryText =
        '机械装备、汽车已形成竞争基础；泛半导体具备差异化潜力；家电和流程行业的方案转化效率及商业闭环仍是主要短板。'

      if (staticMsgId) {
        this.$store.commit('cosmoClaw/UPDATE_MESSAGE_CONTENT_BY_ID', {
          id: staticMsgId,
          content: cardHtml,
          richHtml: true
        })
        var self = this
        return new Promise(function (resolve) {
          self.$nextTick(function () {
            for (let sectionIdx = 0; sectionIdx <= 4; sectionIdx++) {
              const section = self._findVisibleEl(
                `industry-comp-section-${sectionIdx}-${reportId}`
              )
              if (section) section.style.display = 'block'
            }
            const loadingIds = [
              `comp-s2-loading-${reportId}`,
              `comp-s3-loading-${reportId}`
            ]
            loadingIds.forEach((id) => {
              const el = self._findVisibleEl(id)
              if (el) el.style.display = 'none'
            })
            const contentIds = [
              `comp-s2-content-${reportId}`,
              `comp-s3-content-${reportId}`
            ]
            contentIds.forEach((id) => {
              const el = self._findVisibleEl(id)
              if (el) el.style.display = 'block'
            })
            const setText = (id, text) => {
              const el = self._findVisibleEl(id)
              if (el) el.textContent = text
            }
            setText(`comp-label-${reportId}`, '\u62a5\u8868\u5206\u6790\u7ed3\u8bba')
            setText(
              `comp-title-${reportId}`,
              '\u884c\u4e1a\u89e3\u51b3\u65b9\u6848\u7ade\u4e89\u529b\u4e0d\u8db3\u5206\u6790\u7ed3\u8bba'
            )
            setText(`comp-date-${reportId}`, '2026 \u5e74\u4e0a\u534a\u5e74')
            setText(
              `comp-headline-${reportId}`,
              '\u884c\u4e1a\u65b9\u5411\u603b\u4f53\u6b63\u786e\uff0c\u4f46\u8d44\u6e90\u914d\u7f6e\u3001\u4ef7\u503c\u91cf\u5316\u548c\u65b9\u6848\u590d\u5236\u80fd\u529b\u6ca1\u6709\u8ddf\u4e0a\u884c\u4e1a\u5206\u5316\u3002'
            )
            setText(`comp-summary-${reportId}-span`, summaryText)
            setText(
              `comp-adv-${reportId}`,
              '\u673a\u68b0\u88c5\u5907\u548c\u6c7d\u8f66\u5df2\u5f62\u6210\u67d4\u6027\u4ea7\u7ebf\u3001\u8bbe\u5907\u8054\u7f51\u4e0e\u534f\u540c\u5236\u9020\u7ec4\u5408\u65b9\u6848\uff0c\u53ef\u6c89\u6dc0\u4e3a\u8de8\u5ba2\u6237\u590d\u7528\u7684\u6807\u51c6\u5305\u3002'
            )
            setText(
              `comp-short-${reportId}`,
              '\u5bb6\u7535\u4e0e\u6d41\u7a0b\u884c\u4e1a\u7f3a\u5c11\u53ef\u91cf\u5316\u7684\u6295\u8d44\u56de\u62a5\u8bc1\u660e\uff0cAIOT \u540c\u8d28\u5316\u53ca\u9879\u76ee\u7acb\u9879\u5468\u671f\u62c9\u4f4e\u65b9\u6848\u8f6c\u5316\u6548\u7387\u3002'
            )
            setText(`comp-sug-section-title-${reportId}`, '\u51b3\u7b56\u5efa\u8bae')
            compSugTexts.forEach((item, index) => {
              const card = self._findVisibleEl(`comp-sug-card-${reportId}-${index}`)
              if (card) card.style.display = 'flex'
              setText(`comp-sug-title-${reportId}-${index}`, item.title)
              setText(`comp-sug-desc-${reportId}-${index}`, item.desc)
            })
            resolve()
          })
        })
      }
      this.appendLocalMessage('assistant', cardHtml, true)
      this.persistMockMessage('assistant', '[mock:ceo-industry-competitiveness-confirm]')

      // 串行揭示：全部文字打印机效果，按顺序逐渐展示（参考卡奥斯2026年上半年总结流程模式）
      setTimeout(() => {
        // Section 0: 流式输出标题
        this.revealSection(`industry-comp-section-0-${reportId}`, 'block')
        setTimeout(() => {
          this.typeWriterEffect(`comp-label-${reportId}`, '报表分析结论', () => {
            this.typeWriterEffect(
              `comp-title-${reportId}`,
              '行业解决方案竞争力不足分析结论',
              () => {
                this.typeWriterEffect(`comp-date-${reportId}`, '2026 年上半年', () => {
                  // Section 0 完毕 → Section 1（核心结论，打印机效果）
                  this.revealSection(`industry-comp-section-1-${reportId}`, 'block')
                  setTimeout(() => {
                    this.typeWriterEffect(
                      `comp-headline-${reportId}`,
                      '行业方向总体正确，但资源配置、价值量化和方案复制能力没有跟上行业分化。',
                      () => {
                        this.typeWriterEffect(`${section1Id}-span`, summaryText, () => {
                          // Section 1 完毕 → Section 2（优势与短板，loading后展示 + 打印机效果）
                          setTimeout(() => {
                            this.revealSection(
                              `industry-comp-section-2-${reportId}`,
                              'block'
                            )
                            setTimeout(() => {
                              const s3Loader = this._findVisibleEl(
                                `comp-s2-loading-${reportId}`
                              )
                              const s3Content = this._findVisibleEl(
                                `comp-s2-content-${reportId}`
                              )
                              if (s3Loader) s3Loader.style.display = 'none'
                              if (s3Content) s3Content.style.display = 'block'
                              setTimeout(() => {
                                this.typeWriterEffect(
                                  `comp-adv-${reportId}`,
                                  '机械装备和汽车已形成柔性产线、设备联网与协同制造组合方案，可沉淀为跨客户复用的标准包。',
                                  () => {
                                    this.typeWriterEffect(
                                      `comp-short-${reportId}`,
                                      '家电与流程行业缺少可量化的投资回报证明，AIOT 同质化及项目立项周期拉低方案转化效率。',
                                      () => {
                                        // Section 3 完毕 → Section 4（经营风险表格，loading结束后一次性展示）
                                        this.revealSection(
                                          `industry-comp-section-3-${reportId}`,
                                          'block'
                                        )
                                        setTimeout(() => {
                                          const s4Loader = this._findVisibleEl(
                                            `comp-s3-loading-${reportId}`
                                          )
                                          const s4Content = this._findVisibleEl(
                                            `comp-s3-content-${reportId}`
                                          )
                                          if (s4Loader) s4Loader.style.display = 'none'
                                          if (s4Content) {
                                            s4Content.style.display = 'block'
                                          }
                                          // Section 4 完毕 → Section 5（决策建议，逐个卡片打印机效果）
                                          setTimeout(() => {
                                            this.revealSection(
                                              `industry-comp-section-4-${reportId}`,
                                              'block'
                                            )
                                            setTimeout(() => {
                                              this.typeWriterEffect(
                                                `comp-sug-section-title-${reportId}`,
                                                '决策建议',
                                                () => {
                                                  let sugIdx = 0
                                                  const typeNextSug = () => {
                                                    if (sugIdx < compSugTexts.length) {
                                                      // 先显示卡片背景
                                                      const sugCard = this._findVisibleEl(
                                                        `comp-sug-card-${reportId}-${sugIdx}`
                                                      )
                                                      if (sugCard) {
                                                        sugCard.style.display = 'flex'
                                                      }
                                                      this.typeWriterEffect(
                                                        `comp-sug-title-${reportId}-${sugIdx}`,
                                                        compSugTexts[sugIdx].title,
                                                        () => {
                                                          this.typeWriterEffect(
                                                            `comp-sug-desc-${reportId}-${sugIdx}`,
                                                            compSugTexts[sugIdx].desc,
                                                            () => {
                                                              // 当前卡片打印机效果完成后，再加载下一个卡片
                                                              sugIdx++
                                                              setTimeout(
                                                                typeNextSug,
                                                                300
                                                              )
                                                            }
                                                          )
                                                        }
                                                      )
                                                    }
                                                  }
                                                  setTimeout(typeNextSug, 200)
                                                }
                                              )
                                            }, 280)
                                          }, 280)
                                        }, 600)
                                      }
                                    )
                                  }
                                )
                              }, 280)
                            }, 600)
                          }, 800)
                        })
                      }
                    )
                  }, 280)
                })
              }
            )
          })
        }, 200)
      }, 200)
    },
    runCustomerStructure() {
      const title = '客户结构分析'
      const summary = '正在基于客户结构经营报表，诊断客户结构优化问题...'

      const thinkingSteps = [
        '正在对比同期客户数量与收入结构...',
        '正在计算大客户和中小客户数量占比...',
        '正在核对平均客单价与客户集中度...',
        '正在分析客户分层与收入贡献结构...',
        '正在形成客户结构优化建议...'
      ]

      const body = `
        <div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;box-sizing:border-box;">
          <div>
            <div style="display:flex;align-items:center;gap:8px;margin-bottom:8px;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="2"><path d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m-4-9.803a2 2 0 100 4 2 2 0 000-4z"/></svg>
              <span style="font-size:13px;font-weight:700;color:#7c3aed;">客户结构分析</span>
            </div>
            <div style="font-size:14px;font-weight:700;color:#1f2937;margin-bottom:4px;">客户结构经营情况分析结论</div>
            <div style="font-size:11px;color:#94a3b8;margin-bottom:16px;">2026 年上半年</div>
            <div style="padding:14px 16px;border-radius:12px;background:linear-gradient(135deg,rgba(139,92,246,0.06),rgba(124,58,237,0.03));border:1px solid rgba(139,92,246,0.15);margin-bottom:16px;font-size:13px;color:#475569;line-height:1.8;">
              <b style="color:#1f2937;">客户结构小幅优化、客单价有所提升，但收入仍向少数大客户集中。</b><br>
              <span style="font-size:12px;color:#6b7280;">千万元级及以上客户仅占 3.29%，但贡献约 69.8% 收入，集中度偏高。十万元以下客户占 58.99%，需提升标准方案转化、复购和服务效率。</span>
            </div>
            <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;margin-bottom:16px;">
              <div style="padding:14px;border-radius:10px;background:#f0fdf4;border:1px solid rgba(10,166,106,0.15);text-align:center;">
                <div style="font-size:10px;color:#64748b;margin-bottom:4px;">大客户占比</div>
                <div style="font-size:20px;font-weight:800;color:#0aa66a;">3.29%</div>
                <div style="font-size:10px;color:#64748b;margin-top:2px;">28 家 / 851 家</div>
              </div>
              <div style="padding:14px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;text-align:center;">
                <div style="font-size:10px;color:#64748b;margin-bottom:4px;">中小客户占比</div>
                <div style="font-size:20px;font-weight:800;color:#1f2937;">96.71%</div>
                <div style="font-size:10px;color:#64748b;margin-top:2px;">823 家 / 851 家</div>
              </div>
              <div style="padding:14px;border-radius:10px;background:#eff6ff;border:1px solid rgba(45,127,249,0.15);text-align:center;">
                <div style="font-size:10px;color:#64748b;margin-bottom:4px;">平均客单价</div>
                <div style="font-size:20px;font-weight:800;color:#2d7ff9;">187 万</div>
                <div style="font-size:10px;color:#64748b;margin-top:2px;">同比提升 3.3%</div>
              </div>
            </div>
            <div style="margin-bottom:16px;">
              <div style="font-size:12px;font-weight:600;color:#1f2937;margin-bottom:10px;">客户分层收入贡献</div>
              <div style="overflow:hidden;border-radius:10px;border:1px solid #e8ecf0;">
                <table style="width:100%;border-collapse:collapse;font-size:12px;">
                  <thead><tr style="background:#f8fafc;">
                    <th style="padding:8px 12px;text-align:left;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">客户层级</th>
                    <th style="padding:8px 12px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">数量</th>
                    <th style="padding:8px 12px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">占比</th>
                    <th style="padding:8px 12px;text-align:right;font-size:11px;color:#64748b;font-weight:600;border-bottom:2px solid #e8ecf0;">收入贡献</th>
                  </tr></thead>
                  <tbody>
                    <tr><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;font-weight:600;color:#1f2937;">亿元及以上</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#475569;">2</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#475569;">0.24%</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#0aa66a;font-weight:600;">28.5%</td></tr>
                    <tr><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;font-weight:600;color:#1f2937;">千万元级</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#475569;">26</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#475569;">3.05%</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#0aa66a;font-weight:600;">41.3%</td></tr>
                    <tr><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;font-weight:600;color:#1f2937;">百万元级</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#475569;">116</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#475569;">13.63%</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#d98213;font-weight:600;">19.8%</td></tr>
                    <tr><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;font-weight:600;color:#1f2937;">十万元级</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#475569;">185</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#475569;">21.74%</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#d98213;font-weight:600;">7.6%</td></tr>
                    <tr style="background:#f8fafc;"><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;font-weight:700;color:#1f2937;">十万元以下</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;font-weight:700;color:#1f2937;">522</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;font-weight:700;color:#1f2937;">61.34%</td><td style="padding:8px 12px;border-bottom:1px solid #f1f5f9;text-align:right;color:#e54b3d;font-weight:600;">2.8%</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:16px;">
              <div style="padding:12px 14px;border-radius:10px;background:#f0fdf4;border:1px solid rgba(10,166,106,0.12);font-size:11px;color:#475569;line-height:1.7;">
                <b style="color:#0aa66a;">积极变化</b><br>客户结构小幅优化，平均客单价同比提升 3.3%，大客户数量保持稳定。
              </div>
              <div style="padding:12px 14px;border-radius:10px;background:#fef2f2;border:1px solid rgba(229,75,61,0.12);font-size:11px;color:#475569;line-height:1.7;">
                <b style="color:#e54b3d;">主要短板</b><br>十万元以下客户占 61.34% 但仅贡献 2.8% 收入，长尾客户服务成本高效率低。
              </div>
            </div>
            <div>
              <div style="font-size:12px;font-weight:600;color:#1f2937;margin-bottom:10px;">决策建议</div>
              <div style="display:flex;flex-direction:column;gap:10px;">
                <div style="display:flex;align-items:flex-start;gap:10px;padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;">
                  <div style="width:28px;height:28px;border-radius:8px;background:#dbe6ff;display:flex;align-items:center;justify-content:center;flex-shrink:0;">&#127919;</div>
                  <div style="flex:1;"><div style="font-size:12px;font-weight:600;color:#1f2937;">深耕大客户</div><div style="font-size:11px;color:#6b7280;margin-top:2px;">围绕千万元级客户建立专属客户成功团队，提升续约率与增购率，巩固收入基本盘。</div></div>
                  <span style="padding:2px 8px;border-radius:999px;background:#e8f5e9;color:#2e7d32;font-size:10px;font-weight:600;flex-shrink:0;">持续</span>
                </div>
                <div style="display:flex;align-items:flex-start;gap:10px;padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;">
                  <div style="width:28px;height:28px;border-radius:8px;background:#fef3c7;display:flex;align-items:center;justify-content:center;flex-shrink:0;">&#128203;</div>
                  <div style="flex:1;"><div style="font-size:12px;font-weight:600;color:#1f2937;">长尾客户标准化</div><div style="font-size:11px;color:#6b7280;margin-top:2px;">针对十万元以下客户推广标准方案包与自助服务，降低服务成本，提升转化效率。</div></div>
                  <span style="padding:2px 8px;border-radius:999px;background:#fff7ed;color:#d98213;font-size:10px;font-weight:600;flex-shrink:0;">60 天</span>
                </div>
                <div style="display:flex;align-items:flex-start;gap:10px;padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e8ecf0;">
                  <div style="width:28px;height:28px;border-radius:8px;background:#fef2f2;display:flex;align-items:center;justify-content:center;flex-shrink:0;">&#128200;</div>
                  <div style="flex:1;"><div style="font-size:12px;font-weight:600;color:#1f2937;">客户健康度看板</div><div style="font-size:11px;color:#6b7280;margin-top:2px;">建立客户分层监控机制，月度跟踪客单价、复购率与流失率，及时预警客户结构恶化。</div></div>
                  <span style="padding:2px 8px;border-radius:999px;background:#e8f5e9;color:#2e7d32;font-size:10px;font-weight:600;flex-shrink:0;">月度</span>
                </div>
              </div>
            </div>
          </div>
        </div>`

      this.addSmartFlowHistory(title)
      this.$store.commit('cosmoClaw/SET_MESSAGES', [
        this.createLocalMessage('user', title)
      ])
      this.runSmartFlowProgress(
        {
          title,
          status: summary,
          steps: thinkingSteps,
          interval: 650,
          finalBody: body,
          finalOptions: {
            status: '分析完成',
            currentStep: '客户结构分析报告已生成'
          }
        },
        1200
      )
    },
    async runEnterpriseBriefAnalysis() {
      const analysisConfig = this.getEnterpriseBriefAnalysisConfig()
      this.addSmartFlowHistory('企业经营简报分析')
      this.$store.commit('cosmoClaw/SET_MESSAGES', [
        this.createLocalMessage('user', '请深度分析今日内部经营简报')
      ])
      const thinkingId = `thinking-profit-style-${Date.now()}`
      const thinkingSteps = [
        '指标定义智能体：检索今日营收、毛利率、产能利用率、现金流、库存周转与订单准交率指标定义与口径。',
        '指标定义智能体：拉取核心经营指标今日值、预算值、预警阈值与环比变化。数据获取完成。',
        '指标定义智能体：发现毛利率当前17.1%，低于目标18.7%，差1.6pct，触发预警阈值。',
        '本体治理智能体：拆解营收、毛利率、库存与交付指标的原子指标构成与关联链路。',
        '本体治理智能体：核对高毛利订单占比、低价订单占比、主线排产负荷与库存结构。',
        '本体治理智能体：识别出低价订单结构恶化是毛利率下滑的直接原因，原材料成本上升是深层拖累。',
        '经营决策智能体：评估收入稳定、利润承压、产线偏满与库存温和上行的联动影响。',
        '经营决策智能体：计算毛利率每下滑1pct对利润端的影响约为625万元，需立即关注。',
        '经营决策智能体：输出今日经营风险预警与优先处置建议，正在生成每日经营简报...'
      ]
      const title = '每日经营简报'
      const summary =
        '围绕营收、毛利率、产能、现金流、库存与交付六项经营关键指标，联动智能体完成数据查询、结构拆解与风险研判。'
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          title,
          summary,
          thinkingSteps.length
        ),
        true
      )
      let stepIndex = 1
      const thinkingInterval = setInterval(() => {
        if (stepIndex < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIndex)
          stepIndex++
        } else {
          clearInterval(thinkingInterval)
          setTimeout(() => {
            this.removeThinkingCard(thinkingId)
            setTimeout(() => {
              this.renderEnterpriseBriefStreamCard(analysisConfig)
            }, 320)
          }, 500)
        }
      }, 2000)
      this.smartAnalysisTimers.push(thinkingInterval)
    },
    async runCsoEnterpriseBriefAnalysis() {
      const analysisConfig = this.getCsoEnterpriseBriefAnalysisConfig()
      this.addSmartFlowHistory('供应链全局简报分析')
      this.$store.commit('cosmoClaw/SET_MESSAGES', [
        this.createLocalMessage('user', '请深度分析今日供应链全局简报')
      ])
      const thinkingId = `cso-brief-thinking-${Date.now()}`
      const thinkingSteps = [
        '指标定义智能体：检索今日 T-1 交付率、物料齐套率、库存周转、采购降本、供应链健康度与风险预警指标定义与口径。',
        '指标定义智能体：拉取六项供应链核心指标今日值、预算值、预警阈值与环比变化。数据获取完成。',
        '指标定义智能体：发现 T-1 交付率 91%（同比 -2pct）、物料齐套率 91%（同比 -1pct）双指标低于目标值，触发预警。',
        '本体治理智能体：拆解供应链六项指标的原子构成与上下游节点链路，覆盖供应商、工厂、仓储、客户四级。',
        '本体治理智能体：核对 MCU 库存缺口、铜价暴涨、客户流失结构、资质到期四类风险事件与节点映射。',
        '经营决策智能体：评估交付承压、毛利修复、库存温和上行与四类风险并行的联动影响。',
        '经营决策智能体：识别 MCU 库存为最高优风险（17:00 前须响应），输出今日供应链风险预警与处置建议。',
        '经营决策智能体：联动生成每日供应链全局简报...'
      ]
      const title = '每日供应链全局简报'
      const summary =
        '围绕 T-1 交付率、物料齐套率、库存周转、采购降本、供应链健康度、风险预警六项核心指标，联动智能体完成数据查询、结构拆解与风险研判。'
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          title,
          summary,
          thinkingSteps.length
        ),
        true
      )
      let stepIndex = 1
      const thinkingInterval = setInterval(() => {
        if (stepIndex < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIndex)
          stepIndex++
        } else {
          clearInterval(thinkingInterval)
          setTimeout(() => {
            this.removeThinkingCard(thinkingId)
            setTimeout(() => {
              this.renderCsoEnterpriseBriefStreamCard(analysisConfig)
            }, 320)
          }, 500)
        }
      }, 2800)
      this.smartAnalysisTimers.push(thinkingInterval)
    },
    async runPendingDecisionAnalysis() {
      this.clearExistingThinkingCards()
      const analysisConfig = this.getPendingDecisionAnalysisConfig()
      const summary = analysisConfig.summary || {}
      const thinkingSteps = this.getPendingDecisionThinkingSteps(analysisConfig)
      this.addSmartFlowHistory('铺底报价订单决策分析')
      this.$store.commit('cosmoClaw/SET_MESSAGES', [
        this.createLocalMessage('user', '请分析铺底报价订单决策')
      ])
      const thinkingId = `pending-decision-thinking-${Date.now()}`
      this.appendLocalMessage(
        'assistant',
        this.renderEnterpriseBriefThinkingCard(thinkingId, thinkingSteps[0], summary),
        true
      )
      let stepIndex = 1
      const thinkingInterval = setInterval(() => {
        if (stepIndex < thinkingSteps.length) {
          this.updateThinkingCard(thinkingId, thinkingSteps, stepIndex)
          stepIndex++
        } else {
          clearInterval(thinkingInterval)
          setTimeout(() => {
            this.removeThinkingCard(thinkingId)
            setTimeout(() => {
              this.renderPendingDecisionStreamCard(analysisConfig)
            }, 320)
          }, 500)
        }
      }, 800)
      this.smartAnalysisTimers.push(thinkingInterval)
    },
    async runPendingDecisionGrossMarginAnalysis() {
      this.addSmartFlowHistory('待决策事项毛利率分析')
      this.$store.commit('cosmoClaw/SET_MESSAGES', [
        this.createLocalMessage('user', '分析毛利率异常财务分析报告')
      ])
      const thinkingId = 'pending-decision-margin-thinking-' + Date.now()
      const thinkingSteps = [
        '正在从指标字典中检索毛利率异常相关指标...',
        '检索到"毛利率"指标，当前值为17.1%，目标值18.7%，存在1.6个百分点缺口',
        '正在获取财务分析报告相关数据，数据源：SAP月结 + E2E管理口径...',
        '获取成功，正在比对毛利率同比变化：去年同期18.7%，同比下降1.6个百分点',
        '正在获取近5个月趋势数据：1月18.0% → 2月17.8% → 3月17.5% → 4月17.3% → 5月17.1%',
        '趋势确认：毛利率连续5个月下滑，累计下降0.9个百分点，呈加速下行态势',
        '正在联动分析营收、成本、费用三项关联指标，综合评估利润端影响...',
        '关联分析完成：营收端基本稳定（8.2亿），但成本端承压（原材料上涨+采购降本不足），直接侵蚀利润空间',
        '正在归因定位：按供应链端归因拆解毛利率下滑根因...',
        '归因完成：原材料物料成本上升（贡献度62%）+ 采购降本兑现滞后（贡献度38%），均为供应链端因素',
        '汇总分析结论：毛利率异常下降为核心经营风险，四项关差动作预计可追回812万毛利额',
        '分析完成，正在生成毛利率异常分析报告...'
      ]
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          '待决策事项毛利率深度分析',
          '正在对毛利率异常问题进行系统性诊断与供应链端根因归因...',
          thinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            this.renderProfitMarginStreamCard()
          }, 500)
        }
      }, 2000)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    async runCsoPendingBomAnalysis() {
      this.addSmartFlowHistory('原材料成本上行归因与传导决策分析')
      this.$store.commit('cosmoClaw/SET_MESSAGES', [
        this.createLocalMessage('user', '请分析 原材料 成本上行归因与传导决策')
      ])
      const thinkingId = 'cso-bom-thinking-' + Date.now()
      const thinkingSteps = [
        '财务总览 bom_alert：财务总览反馈 原材料 成本上行， 8.2% / 铜 5.4% / 锡 4.1%，供应商集中度 87%-92%。',
        '成本归因 skill cost_attribution：涨跌归因分析： 主因铜箔+环氧树脂传导；铜主因 LME 上行；锡主因缅甸选矿减产。年新增成本约 1240 万，影响毛利率约 0.9pct。',
        '寻源采购 skill lock_eval：锁价可行性评估：供应链已正式致函涨价，集中度 87%-92% 议价能力弱，锁价/保价/空间为 0。',
        '经营决策智能体 pass_through_decision：供应链利润无降价空间，内部消化难再降毛利 0.5pct 不可持续。建议将成本传导至客户，进入客户调价方案评估流程。'
      ]
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          '原材料成本上行归因与传导决策',
          '联动财务总览、成本归因、寻源采购、经营决策四类智能体，进行 原材料 上行根因归因与传导路径推演...',
          thinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          setTimeout(() => {
            this.removeThinkingCard(thinkingId)
            setTimeout(() => {
              this.renderCsoPendingBomStreamCard()
            }, 320)
          }, 500)
        }
      }, 2800)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    async runProfitMarginAbnormalAnalysis() {
      this.addSmartFlowHistory('分析毛利率')
      this.$store.commit('cosmoClaw/SET_MESSAGES', [
        this.createLocalMessage('user', '分析毛利率')
      ])
      const thinkingId = 'thinking-profit-' + Date.now()
      const thinkingSteps = [
        '正在从指标字典中检索毛利率相关指标...',
        '检索到"毛利率"指标，类型：复合指标，分类：毛利管理，口径：E2E管理口径',
        '正在获取毛利率原始数据，数据源：SAP月结（5月）+ E2E管理口径损益表...',
        '获取成功，当前毛利率数据：17.1%，目标值18.7%，低于目标1.6个百分点',
        '开始计算毛利率同比变化：17.1% - 18.7% = -1.6个百分点，同比下降明显',
        '正在获取近5个月环比数据以分析趋势走向...',
        '趋势分析完成：1月18.0% → 2月17.8% → 3月17.5% → 4月17.3% → 5月17.1%，连续5个月下滑',
        '正在归因分析：按PVMC四维度拆解毛利率变动驱动因素...',
        '归因完成：销量下滑-5.2%（首要因素）+ 价格竞争-1.8% + 结构调整-1.4% + 成本改善+3.2% = 净影响-1.6%',
        '交叉验证：拆解结果与实际下滑幅度一致，分析可信度通过验证',
        '汇总分析结论：毛利率持续下降主因是低价订单结构恶化与原材料成本上涨，利润修复为当前最大经营风险',
        '分析完成，正在生成毛利率分析报告...'
      ]
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          '毛利率深度分析',
          '正在从多维度分析毛利率变动原因，进行趋势研判与归因定位...',
          thinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            this.renderProfitMarginStreamCard()
          }, 500)
        }
      }, 2000)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    renderProfitMarginStreamCard() {
      this.$store.commit('cosmoClaw/SET_LOCAL_DEMO_MODE', false)
      const vm = this
      const replyId = 'profit-margin-stream-' + Date.now()
      const section1Id = `profit-summary-${replyId}`
      const section3Id = `profit-conclusion-${replyId}`

      const summaryText =
        '今年毛利率为 17.1%，去年同期为 18.7%，同比下降 1.6 个百分点。' +
        '从月度趋势来看，今年各月毛利水平均低于去年同期，呈现持续下滑态势。'

      const analysisText =
        '今年毛利率为 17.1%，去年同期为 18.7%，同比下降 1.6 个百分点。' +
        '从月度趋势来看，今年各月毛利水平均低于去年同期，呈现持续下滑态势。'

      const rootCauseText =
        '原材料成本上升（62%）为核心驱动因素，原材料+8.2%、铜+5.4%、锡+4.1%持续推高单位成本，影响毛利额-412万，拉低毛利率-1.02pct，主力产品A-1000/B-2000承压最重。采购降本兑现不足（38%）亦加重压力，年度降本目标820万仅兑现60%（缺口328万），影响毛利额-256万，拉低毛利率-0.63pct。'

      const closingText =
        'CFO已制定四项关差方案预计追回毛利额118.2万，目标恢复至18%以上。'

      const cardHtml = `
        <div id="profit-stream-${replyId}" style="margin-top:2px;display:flex;flex-direction:column;gap:10px;">

          <div id="profit-section-0-${replyId}" style="display:none;padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:6px;">
              <div style="font-size:15px;font-weight:700;color:#1f2937;">毛利率分析报告</div>
              <span style="display:inline-flex;align-items:center;padding:3px 10px;border-radius:999px;background:#fef2f2;color:#dc2626;font-size:11px;font-weight:600;">毛利率预警</span>
            </div>
            <div style="font-size:11px;color:#94a3b8;">毛利率 = (销售收入 - 销售成本) / 销售收入 × 100%</div>
          </div>

          <div id="profit-section-1-${replyId}" style="display:none;padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(74,95,243,0.08),rgba(14,165,233,0.05));border:1px solid rgba(74,95,243,0.16);opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div id="${section1Id}" style="font-size:12px;color:#475569;line-height:1.8;min-height:22px;"></div>
          </div>

          <div id="profit-section-2-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;">
              <div style="font-size:12px;font-weight:600;color:#1f2937;margin-bottom:10px;">毛利率近5个月趋势对比</div>
              <div id="profit-chart-loading-${replyId}" style="display:none;height:190px;flex-direction:column;align-items:center;justify-content:center;gap:8px;background:#f8fafc;border-radius:8px;">
                <div style="width:24px;height:24px;border:3px solid #e8ecf0;border-top:3px solid #4A5FF3;border-radius:50%;animation:cl-spin 0.8s linear infinite;"></div>
                <span style="font-size:11px;color:#94a3b8;">正在加载图表数据...</span>
              </div>
              <div id="profit-chart-svg-${replyId}" style="display:none;">
                <svg width="100%" height="190" viewBox="0 0 400 190" preserveAspectRatio="none">
                  <defs>
                    <linearGradient id="barGrad1_${replyId}" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#4A5FF3;stop-opacity:1"/><stop offset="100%" style="stop-color:#4A5FF3;stop-opacity:0.5"/></linearGradient>
                    <linearGradient id="barGrad2_${replyId}" x1="0%" y1="0%" x2="0%" y2="100%"><stop offset="0%" style="stop-color:#FF6B6B;stop-opacity:1"/><stop offset="100%" style="stop-color:#FF6B6B;stop-opacity:0.5"/></linearGradient>
                    <filter id="barShadow_${replyId}"><feDropShadow dx="0" dy="3" stdDeviation="3" flood-color="#000000" flood-opacity="0.06"/></filter>
                  </defs>
                  <g transform="translate(40,15)">
                    <line x1="0" y1="0" x2="340" y2="0" stroke="#f0f2f5" stroke-width="1"/>
                    <line x1="0" y1="37" x2="340" y2="37" stroke="#f0f2f5" stroke-width="1"/>
                    <line x1="0" y1="74" x2="340" y2="74" stroke="#f0f2f5" stroke-width="1"/>
                    <line x1="0" y1="111" x2="340" y2="111" stroke="#f0f2f5" stroke-width="1"/>
                    <line x1="0" y1="148" x2="340" y2="148" stroke="#f0f2f5" stroke-width="1"/>
                    <rect x="15" y="68" width="45" height="75" fill="url(#barGrad1_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
                    <rect x="85" y="81" width="45" height="62" fill="url(#barGrad1_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
                    <rect x="155" y="54" width="45" height="89" fill="url(#barGrad1_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
                    <rect x="225" y="60" width="45" height="83" fill="url(#barGrad1_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
                    <rect x="295" y="40" width="45" height="103" fill="url(#barGrad1_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
                    <rect x="15" y="110" width="45" height="31" fill="url(#barGrad2_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
                    <rect x="85" y="119" width="45" height="22" fill="url(#barGrad2_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
                    <rect x="155" y="106" width="45" height="35" fill="url(#barGrad2_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
                    <rect x="225" y="115" width="45" height="26" fill="url(#barGrad2_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
                    <rect x="295" y="89" width="45" height="52" fill="url(#barGrad2_${replyId})" rx="4" filter="url(#barShadow_${replyId})"/>
                    <text x="37" y="61" text-anchor="middle" font-size="10" fill="#4A5FF3" font-weight="600">20%</text>
                    <text x="107" y="74" text-anchor="middle" font-size="10" fill="#4A5FF3" font-weight="600">18%</text>
                    <text x="177" y="47" text-anchor="middle" font-size="10" fill="#4A5FF3" font-weight="600">22%</text>
                    <text x="247" y="53" text-anchor="middle" font-size="10" fill="#4A5FF3" font-weight="600">21%</text>
                    <text x="317" y="33" text-anchor="middle" font-size="10" fill="#4A5FF3" font-weight="600">24%</text>
                    <text x="37" y="103" text-anchor="middle" font-size="10" fill="#FF6B6B" font-weight="600">11%</text>
                    <text x="107" y="112" text-anchor="middle" font-size="10" fill="#FF6B6B" font-weight="600">9%</text>
                    <text x="177" y="99" text-anchor="middle" font-size="10" fill="#FF6B6B" font-weight="600">12%</text>
                    <text x="247" y="108" text-anchor="middle" font-size="10" fill="#FF6B6B" font-weight="600">10%</text>
                    <text x="317" y="82" text-anchor="middle" font-size="10" fill="#FF6B6B" font-weight="600">16%</text>
                    <polyline points="37,68 107,81 177,54 247,60 317,40" fill="none" stroke="#4A5FF3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.9"/>
                    <polyline points="37,110 107,119 177,106 247,115 317,89" fill="none" stroke="#FF6B6B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" opacity="0.9"/>
                  </g>
                  <g transform="translate(40,165)">
                    <text x="37" y="12" text-anchor="middle" font-size="10" fill="#64748b">1月</text>
                    <text x="107" y="12" text-anchor="middle" font-size="10" fill="#64748b">2月</text>
                    <text x="177" y="12" text-anchor="middle" font-size="10" fill="#64748b">3月</text>
                    <text x="247" y="12" text-anchor="middle" font-size="10" fill="#64748b">4月</text>
                    <text x="317" y="12" text-anchor="middle" font-size="10" fill="#64748b">5月</text>
                  </g>
                  <g transform="translate(25,15)">
                    <text x="5" y="12" text-anchor="end" font-size="9" fill="#94a3b8" font-weight="500">25%</text>
                    <text x="5" y="49" text-anchor="end" font-size="9" fill="#94a3b8">20%</text>
                    <text x="5" y="86" text-anchor="end" font-size="9" fill="#94a3b8">15%</text>
                    <text x="5" y="123" text-anchor="end" font-size="9" fill="#94a3b8">10%</text>
                    <text x="5" y="160" text-anchor="end" font-size="9" fill="#94a3b8">5%</text>
                  </g>
                </svg>
              </div>
              <div id="profit-chart-legend-${replyId}" style="display:none;">
                <div style="display:flex;justify-content:flex-start;gap:32px;margin-top:4px;padding-left:10px;">
                  <span style="display:flex;align-items:center;gap:6px;">
                    <span style="width:10px;height:10px;background:#4A5FF3;border-radius:3px;"></span>
                    <span style="color:#64748b;font-size:11px;">去年同期</span>
                  </span>
                  <span style="display:flex;align-items:center;gap:6px;">
                    <span style="width:10px;height:10px;background:#FF6B6B;border-radius:3px;"></span>
                    <span style="color:#64748b;font-size:11px;">今年同期</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div id="profit-section-3-${replyId}" style="display:none;padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="font-size:12px;color:#4A5FF3;font-weight:600;margin-bottom:10px;">数据分析结论</div>
            <div id="profit-analysis-text-${replyId}" style="font-size:12px;color:#475569;line-height:1.8;min-height:22px;margin-bottom:10px;"></div>
            <div id="profit-rootcause-${replyId}" style="display:none;margin-bottom:10px;padding:10px 12px;border-radius:10px;background:#fef2f2;border:1px solid #fecaca;">
              <div style="font-size:12px;font-weight:700;color:#e54b3d;margin-bottom:6px;">根因归因</div>
              <div id="profit-rootcause-text-${replyId}" style="font-size:12px;color:#4b5563;line-height:1.7;min-height:18px;"></div>
            </div>
            <div id="${section3Id}" style="font-size:12px;color:#475569;line-height:1.8;min-height:22px;"></div>
          </div>

          <div id="profit-section-4-${replyId}" style="display:none;opacity:0;transform:translateY(8px);transition:all .28s ease;">
            <div style="display:flex;align-items:center;gap:12px;padding:10px 14px;border-radius:10px;background:#f8f9fc;border:1px solid #e8ecf0;">
              <button type="button" onclick="if(window.startPVMCMAnalysis){window.startPVMCMAnalysis();}" style="display:inline-flex;align-items:center;gap:6px;padding:8px 16px;border-radius:8px;background:linear-gradient(135deg,#4A5FF3,#637afc);color:#ffffff;font-size:12px;font-weight:600;border:none;cursor:pointer;box-shadow:0 2px 8px rgba(74,95,243,0.25);">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
                PVMC模型分析毛利率波动原因
              </button>
            </div>
          </div>
        </div>
      `
      this.followUpRegistry = this.followUpRegistry || {}
      this.followUpRegistry['profit-margin-followup'] = {
        title: '追问当前毛利率异常结论',
        prompt:
          '基于刚才毛利率异常处理的结论，请继续展开分析销量下滑、成本上升和价格竞争三项因素各自的影响路径、关键证据和优先处理建议。'
      }

      this.appendLocalMessage('assistant', cardHtml, true)

      // 串行：每个区块通过回调链式触发，前一个完全结束后再启动下一个
      setTimeout(() => this.revealSection(`profit-section-0-${replyId}`, 'block'), 160)

      setTimeout(() => {
        this.revealSection(`profit-section-1-${replyId}`, 'block')
        setTimeout(() => {
          this.typeWriterEffect(section1Id, summaryText, () => {
            // 区块2打字完毕 → 启动区块3：图表（loading → SVG）
            this.revealSection(`profit-section-2-${replyId}`, 'block')
            const loadingEl = vm._findVisibleEl(`profit-chart-loading-${replyId}`)
            if (loadingEl) loadingEl.style.display = 'flex'
            // loading 1.2秒后切换到 SVG
            setTimeout(() => {
              const loadingE = vm._findVisibleEl(`profit-chart-loading-${replyId}`)
              const svgE = vm._findVisibleEl(`profit-chart-svg-${replyId}`)
              const legendE = vm._findVisibleEl(`profit-chart-legend-${replyId}`)
              if (loadingE) loadingE.style.display = 'none'
              if (svgE) {
                svgE.style.display = 'block'
                svgE.style.opacity = '0'
                svgE.style.transition = 'opacity 0.5s ease'
                setTimeout(() => {
                  svgE.style.opacity = '1'
                }, 50)
              }
              if (legendE) {
                legendE.style.display = 'block'
                legendE.style.opacity = '0'
                legendE.style.transition = 'opacity 0.3s ease'
                setTimeout(() => {
                  legendE.style.opacity = '1'
                }, 200)
              }
              // 图表加载完 → 启动区块4：数据分析结论
              setTimeout(() => {
                this.revealSection(`profit-section-3-${replyId}`, 'block')
                setTimeout(() => {
                  this.typeWriterEffect(
                    `profit-analysis-text-${replyId}`,
                    analysisText,
                    () => {
                      const rootEl = vm._findVisibleEl(`profit-rootcause-${replyId}`)
                      if (rootEl) rootEl.style.display = 'block'
                      setTimeout(() => {
                        this.typeWriterEffect(
                          `profit-rootcause-text-${replyId}`,
                          rootCauseText,
                          () => {
                            setTimeout(() => {
                              this.typeWriterEffect(section3Id, closingText, () => {
                                // 数据分析结论打完 → 启动区块5：按钮
                                this.revealSection(
                                  `profit-section-4-${replyId}`,
                                  'block'
                                )
                              })
                            }, 280)
                          }
                        )
                      }, 280)
                    }
                  )
                }, 200)
              }, 300)
            }, 1200)
          })
        }, 280)
      }, 480)
    },
    async triggerCfoMarginFlow(customText, titleText) {
      this._cfoMarginIntroText = customText || null
      const thinkingId = 'cfo-margin-thinking-' + Date.now()
      const thinkingSteps = [
        '正在从指标字典中检索毛利率相关指标...',
        '检索到毛利率指标，计算周期：本月',
        '正在获取毛利率原始数据...',
        '获取成功，当前毛利率数据：17.1%（目标值18.7%）',
        '正在综合计算分析：同比下降1.6个百分点，低于目标值1.6个百分点'
      ]
      const title = titleText || customText || '分析毛利率中'
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          title,
          '正在分析毛利率异常问题，进行系统性诊断与根因归因...',
          thinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            this.renderCfoMarginCardWithTypewriter()
          }, 500)
        }
      }, 1500)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    renderCfoMarginCardWithTypewriter(staticMsgId) {
      const analysisId = staticMsgId ? '_' + String(staticMsgId).slice(-6) : '_' + Date.now()
      const typingId = 'cfo-margin-typing-' + analysisId
      const taskLabel = this._cfoMarginIntroText
        ? (this._cfoMarginIntroText.match(/围绕"([^"]+)"/) || [])[1] || '分析毛利率'
        : '分析毛利率'
      const introText =
        this._cfoMarginIntroText ||
        '任务已收到。围绕"' +
          taskLabel +
          '"，我会先校准营收达成、毛利波动、回款节奏和现金流安全垫进行分析，我将使用以下 E2E 报表进行数据分析：'
      this._cfoMarginIntroText = null

      const cardHtml = `
        <div data-ceo-card="shell" style="background:#ffffff;border:1px solid #e8ecf0;border-radius:14px;padding:16px;box-shadow:0 4px 16px rgba(0,0,0,0.04);width:100%;min-width:280px;box-sizing:border-box;">
          <div style="min-width:0;width:100%;box-sizing:border-box;">
            <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;">
              <div style="width:32px;height:32px;border-radius:50%;background:linear-gradient(135deg,#10b981,#34d399);display:flex;align-items:center;justify-content:center;color:#ffffff;font-size:14px;font-weight:600;">C</div>
              <div>
                <div style="font-size:12px;font-weight:600;color:#1f2937;">财务数字人</div>
                <div style="font-size:10px;color:#8c9bab;">刚刚</div>
              </div>
            </div>
            <div id="${typingId}" style="font-size:13px;color:#5a6b7e;line-height:1.7;width:100%;min-height:22px;"></div>
            <div id="cfo-margin-card-${analysisId}" style="display:none;margin-top:12px;padding:10px;border-radius:10px;background:#f0fdf4;border:1px solid #dcfce7;">
              <div style="display:flex;align-items:center;gap:8px;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
                <span onclick="if(window.openE2EReport){window.openE2EReport();}" style="font-size:12px;color:#10b981;font-weight:600;cursor:pointer;">E2E 报表</span>
              </div>
            </div>
            <div id="cfo-margin-buttons-${analysisId}" style="display:none;margin-top:12px;display:flex;gap:8px;">
              <button type="button" onclick="if(window.triggerCfoMarginAnalysis){window.triggerCfoMarginAnalysis();}" style="padding:6px 14px;border-radius:6px;background:#10b981;color:#ffffff;font-size:11px;font-weight:600;border:none;cursor:pointer;">同意</button>
              <button type="button" onclick="if(confirm('确定要拒绝本次毛利率分析吗？')){if(window.cancelCfoMarginAnalysis){window.cancelCfoMarginAnalysis();}}" style="padding:6px 14px;border-radius:6px;background:#f1f5f9;color:#64748b;font-size:11px;font-weight:500;border:none;cursor:pointer;">拒绝</button>
            </div>
          </div>
        </div>
      `
      this.appendLocalMessage('assistant', cardHtml, true)

      const chars = introText.split('')
      let i = 0
      const typeTimer = setInterval(() => {
        const el = this._findVisibleEl(typingId)
        if (!el) {
          clearInterval(typeTimer)
          return
        }
        if (i < chars.length) {
          el.textContent += chars[i]
          i++
        } else {
          clearInterval(typeTimer)
          setTimeout(() => {
            const cardEl = this._findVisibleEl(`cfo-margin-card-${analysisId}`)
            if (cardEl) {
              cardEl.style.display = 'inline-block'
              cardEl.style.opacity = '0'
              cardEl.style.transform = 'translateY(8px)'
              cardEl.style.transition = 'opacity 0.3s ease, transform 0.3s ease'
              requestAnimationFrame(() => {
                cardEl.style.opacity = '1'
                cardEl.style.transform = 'translateY(0)'
              })
            }
            setTimeout(() => {
              const buttonsEl = this._findVisibleEl(`cfo-margin-buttons-${analysisId}`)
              if (buttonsEl) {
                buttonsEl.style.display = 'flex'
                buttonsEl.style.opacity = '0'
                buttonsEl.style.transform = 'translateY(8px)'
                buttonsEl.style.transition = 'opacity 0.3s ease, transform 0.3s ease'
                requestAnimationFrame(() => {
                  buttonsEl.style.opacity = '1'
                  buttonsEl.style.transform = 'translateY(0)'
                })
              }
            }, 200)
          }, 300)
        }
      }, 25)
      this.smartAnalysisTimers.push(typeTimer)
      if (staticMsgId) {
        this.$store.commit('cosmoClaw/UPDATE_MESSAGE_CONTENT_BY_ID', {
          id: staticMsgId,
          content: cardHtml,
          richHtml: true
        })
        var self = this
        return new Promise(function (resolve) {
          self.$nextTick(function () {
            var cardEl = self._findVisibleEl('cfo-margin-card-' + analysisId)
            if (cardEl) {
              cardEl.style.display = 'inline-block'
              cardEl.style.opacity = '1'
              cardEl.style.transform = 'translateY(0)'
            }
            var buttonsEl = self._findVisibleEl('cfo-margin-buttons-' + analysisId)
            if (buttonsEl) {
              buttonsEl.style.display = 'flex'
              buttonsEl.style.opacity = '1'
              buttonsEl.style.transform = 'translateY(0)'
            }
            resolve()
          })
        })
      }
      this.persistMockMessage('assistant', '[mock:cfo-margin-entry]')
    },
    triggerCfoScenario(scenario, userText) {
      const handlers = {
        margin: () => {
          const task = String(userText || '毛利率下滑诊断').trim()
          // title 仅取 @mention 后的实际任务文本
          const titleText = task.replace(/@\S+\s*/, '').trim() || '分析毛利率'
          const customText =
            '任务已收到，围绕"' +
            titleText +
            '"，我会先校准营收达成、毛利波动、回款节奏和现金流安全垫进行分析，我将使用以下 E2E 报表进行数据分析：'
          this.triggerCfoMarginFlow(customText, titleText)
        },
        cost: () => this.triggerCfoCostScenario(),
        report: () => this.triggerCfoReportScenario(),
        cash: () => this.triggerCfoCashScenario()
      }
      const handler = handlers[scenario]
      if (handler) handler()
    },
    triggerCeoH1Summary() {
      this.forceScrollToBottom()
      const thinkingId = 'ceo-h1-thinking-' + Date.now()
      const thinkingSteps = [
        '正在核对收入、签约、毛利、利润与效率指标...',
        '正在对比 H1 目标、实际值与上年同期...',
        '正在识别收入结构、盈利水平与经营效率偏差...',
        '正在生成 1—6 月收入、签约、毛利率与利润率分析图...',
        '正在形成 CEO 上半年经营结论...'
      ]
      this.appendLocalMessage(
        'assistant',
        this.renderCeoThinkingCard(
          thinkingId,
          thinkingSteps[0],
          '上半年经营复盘',
          '正在从规模、结构、盈利和效率四个维度形成管理结论。',
          thinkingSteps.length
        ),
        true
      )
      let stepIdx = 1
      const thinkTimer = setInterval(() => {
        if (stepIdx < thinkingSteps.length) {
          this.updateCeoThinkingCard(thinkingId, thinkingSteps, stepIdx)
          stepIdx++
        } else {
          clearInterval(thinkTimer)
          this.removeThinkingCard(thinkingId)
          setTimeout(() => {
            this.renderCeoH1SummaryCard()
          }, 500)
        }
      }, 1800)
      this.smartAnalysisTimers.push(thinkTimer)
    },
    renderCeoH1SummaryCard(staticMsgId) {
      console.log('[H1_CARD] Called with staticMsgId:', staticMsgId, 'type:', typeof staticMsgId, 'truthy:', !!staticMsgId, new Error().stack)
      const uniqueSuffix = staticMsgId ? '_' + String(staticMsgId).slice(-6) : '_' + Date.now()
      const reportId = 'ceo-h1-summary-' + uniqueSuffix
      const section1Id = `h1-summary-${reportId}`
      const section3Id = `h1-charts-${reportId}`
      const section5Id = `h1-findings-${reportId}`

      // ============ 卡奥斯 2026 H1 经营数据 ============
      const revenueData = {
        id: 'h1-revenue',
        title: '上半年（1-6月）收入情况',
        unit: '万元',
        summary: {
          h1Total: 368558.696,
          h1External: 158824.0755,
          h1Target: 397858.7742,
          h1Prior: 340309.9478,
          targetCompletion: 92.6356,
          yoy: 8.3009,
          externalShare: 43.09
        },
        rows: [
          {
            month: '1月',
            total: 48097.6956,
            external: 21346.189,
            target: 43578.0,
            prior: 41637.41
          },
          {
            month: '2月',
            total: 49026.9364,
            external: 19503.0488,
            target: 47843.0,
            prior: 46529.1492
          },
          {
            month: '3月',
            total: 59023.9343,
            external: 25178.8976,
            target: 64686.0,
            prior: 51976.8011
          },
          {
            month: '4月',
            total: 61048.8471,
            external: 28384.0403,
            target: 62060.0,
            prior: 58316.9171
          },
          {
            month: '5月',
            total: 61357.2454,
            external: 26227.7433,
            target: 61403.0,
            prior: 57572.7152
          },
          {
            month: '6月',
            total: 60329.414,
            external: 30427.5547,
            target: 66688.0,
            prior: 55920.6596
          }
        ]
      }

      const signingData = {
        id: 'h1-signing',
        title: '上半年（1-6月）签约情况',
        unit: '万元',
        summary: {
          h1Total: 243482.7099,
          h1External: 219488.0154,
          h1Target: 244212.9,
          h1Prior: 174866.9233,
          targetCompletion: 99.7,
          yoy: 39.24,
          externalShare: 90.15
        },
        rows: [
          {
            month: '1月',
            total: 24328.1656,
            external: 23189.4188,
            target: 21962.0,
            prior: 24358.3188
          },
          {
            month: '2月',
            total: 26177.1718,
            external: 21443.3572,
            target: 25492.0,
            prior: 21240.8914
          },
          {
            month: '3月',
            total: 36852.2983,
            external: 33965.4301,
            target: 35916.0,
            prior: 19838.1138
          },
          {
            month: '4月',
            total: 52801.2126,
            external: 48719.758,
            target: 43279.0,
            prior: 23819.0723
          },
          {
            month: '5月',
            total: 38493.2218,
            external: 32154.6859,
            target: 41779.0,
            prior: 21567.7716
          },
          {
            month: '6月',
            total: 40541.8329,
            external: 37052.8454,
            target: 47623.0,
            prior: 51005.866
          }
        ]
      }

      const marginData = {
        id: 'gross-margin',
        title: '整体毛利率实际曲线',
        unit: '%',
        summary: {
          h1WeightedActual: 15.852,
          h1Target: 19.3875,
          targetGap: -3.5355,
          h1Prior: 18.184,
          yoy: -2.332
        },
        rows: [
          { month: '1月', actual: 16.8125, target: 19.3467, gap: -2.5342 },
          { month: '2月', actual: 16.6666, target: 19.1762, gap: -2.5096 },
          { month: '3月', actual: 16.5764, target: 18.3709, gap: -1.7945 },
          { month: '4月', actual: 14.0653, target: 18.3213, gap: -4.256 },
          { month: '5月', actual: 14.5461, target: 20.7579, gap: -6.2118 },
          { month: '6月', actual: 16.5091, target: 19.5781, gap: -3.069 }
        ]
      }

      const profitData = {
        id: 'h1-profit',
        title: '上半年（1-6月）利润情况',
        unit: '万元',
        summary: {
          h1Profit: 398.1785,
          h1Target: 5394.5117,
          h1Prior: 2464.2049,
          targetCompletion: 7.3812,
          yoy: -83.8415
        },
        rows: [
          {
            month: '1月',
            profit: 236.8357,
            target: 199.9545,
            prior: 55.2381,
            completionRate: 118.4448,
            growthRate: 328.7542
          },
          {
            month: '2月',
            profit: 550.7392,
            target: 499.9618,
            prior: 47.227,
            completionRate: 110.1563,
            growthRate: 1066.152
          },
          {
            month: '3月',
            profit: 808.3708,
            target: 800.4517,
            prior: 727.8122,
            completionRate: 100.9893,
            growthRate: 11.0686
          },
          {
            month: '4月',
            profit: 910.4645,
            target: 849.8077,
            prior: 241.5045,
            completionRate: 107.1377,
            growthRate: 276.9969
          },
          {
            month: '5月',
            profit: 855.6235,
            target: 850.4716,
            prior: 334.3637,
            completionRate: 100.6058,
            growthRate: 155.8961
          },
          {
            month: '6月',
            profit: 885.4352,
            target: 800.1566,
            prior: 477.3742,
            completionRate: 110.6577,
            growthRate: 85.4803
          }
        ]
      }

      // ============ 辅助函数 ============
      const fmtPct = (n, digits = 1) => {
        if (n === undefined || n === null || isNaN(n)) return '-'
        return Number(n).toFixed(digits)
      }

      const headlineText = '规模未达预期，增长质量承压，利润结构需要重新校准。'
      const verdictText = `收入完成 H1 目标的 ${fmtPct(
        revenueData.summary.targetCompletion,
        1
      )}%，签约额完成 ${fmtPct(
        signingData.summary.targetCompletion,
        1
      )}% 且同比增长 ${fmtPct(signingData.summary.yoy, 1)}%；但毛利率降至 ${fmtPct(
        marginData.summary.h1WeightedActual,
        1
      )}%，同比下降 ${fmtPct(
        Math.abs(marginData.summary.yoy),
        1
      )} 个百分点。管理利润仅完成 ${fmtPct(
        profitData.summary.targetCompletion,
        1
      )}%，尚未形成可持续的经营改善。`

      const findings = [
        {
          id: '01',
          title: '增长存在，但不是高质量增长',
          desc:
            '收入与签约实现增长，外单占比没有同步提升，新增业务尚未有效转化为更优的业务结构和毛利水平。'
        },
        {
          id: '02',
          title: '利润"达标"掩盖了经营性缺口',
          desc:
            '费用率下降带来利润改善，但毛利率和人效同步下滑，说明利润更多来自节流与非经营性因素，而不是核心经营能力增强。'
        },
        {
          id: '03',
          title: '全年目标需要从结果管理转向过程攻坚',
          desc:
            'H2 的收入、签约、毛利和利润要求显著高于 H1，必须建立订单质量、项目毛利和回款联动的周度经营机制。'
        }
      ]

      const cardHtml = `
        <div id="h1-report-${reportId}" style="margin-top:2px;display:flex;flex-direction:column;gap:10px;">
          <style>@keyframes cl-spin-${reportId}{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}</style>
          <div id="h1-section-0-${reportId}" style="padding:14px 15px;border-radius:12px;background:linear-gradient(135deg,rgba(74,95,243,0.08),rgba(14,165,233,0.05));border:1px solid rgba(74,95,243,0.16);display:none;">
            <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#4A5FF3" stroke-width="2"><path d="M20 7h-9M14 17H5m11 0a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2m9-9a2 2 0 0 1 2 2v3.5a2.5 2.5 0 0 1-2.5 2.5H14"/></svg>
              <span id="h1-s0-label-${reportId}" style="font-size:12px;font-weight:600;color:#4A5FF3;"></span>
            </div>
            <div id="h1-s0-title-${reportId}" style="font-size:14px;font-weight:700;color:#1f2937;margin-bottom:4px;"></div>
            <div id="h1-s0-date-${reportId}" style="font-size:11px;color:#94a3b8;"></div>
          </div>

          <div id="h1-section-1-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div style="display:flex;align-items:flex-start;gap:10px;">
              <div style="width:32px;height:32px;border-radius:8px;background:#fef3c7;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
              </div>
              <div id="${section1Id}" style="font-size:12px;color:#475569;line-height:1.8;min-height:60px;">
                <strong id="h1-s1-headline-${reportId}" style="font-weight:700;color:#1f2937;"></strong>
                <span id="${section1Id}-span" style="display:block;margin-top:4px;"></span>
              </div>
            </div>
          </div>

          <div id="h1-section-2-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
              <div style="font-size:12px;font-weight:600;color:#1f2937;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4A5FF3" stroke-width="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg><span style="margin-left:6px;">核心经营看板</span></div>
              <div style="font-size:10px;color:#94a3b8;">实际值 / 目标完成 / 同比</div>
            </div>
            <div id="h1-metrics-loading-${reportId}" style="display:flex;height:160px;flex-direction:column;align-items:center;justify-content:center;gap:8px;background:#f8fafc;border-radius:8px;">
              <div style="width:24px;height:24px;border:3px solid #e8ecf0;border-top:3px solid #4A5FF3;border-radius:50%;animation:cl-spin-${reportId} 0.8s linear infinite;"></div>
              <span style="font-size:11px;color:#94a3b8;">正在加载经营数据...</span>
            </div>
            <div id="h1-metrics-content-${reportId}" style="display:none;">
              <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:10px;">
                <div style="padding:14px;border-radius:12px;background:#ffffff;border:1px solid #eef2f6;box-shadow:0 2px 6px rgba(0,0,0,0.03);text-align:center;">
                  <div style="font-size:10px;color:#94a3b8;margin-bottom:6px;">营业收入</div>
                  <div style="font-size:18px;font-weight:700;color:#0f172a;line-height:1.3;">368,559<span style="font-size:10px;font-weight:400;color:#94a3b8;margin-left:2px;">万元</span><div style="display:flex;gap:6px;margin-top:6px;justify-content:center;"><span style="padding:2px 6px;border-radius:4px;background:rgba(245,158,11,0.1);font-size:9px;font-weight:600;color:#d97706;">目标完成 92.6%</span><span style="padding:2px 6px;border-radius:4px;background:rgba(34,197,94,0.1);font-size:9px;font-weight:600;color:#16a34a;">同比 +8.3%</span></div></div>
                </div>
                <div style="padding:14px;border-radius:12px;background:#ffffff;border:1px solid #eef2f6;box-shadow:0 2px 6px rgba(0,0,0,0.03);text-align:center;">
                  <div style="font-size:10px;color:#94a3b8;margin-bottom:6px;">外单占比</div>
                  <div style="font-size:18px;font-weight:700;color:#0f172a;line-height:1.3;">51.07<span style="font-size:10px;font-weight:400;color:#94a3b8;margin-left:2px;">%</span><div style="display:flex;gap:6px;margin-top:6px;justify-content:center;"><span style="padding:2px 6px;border-radius:4px;background:rgba(239,68,68,0.1);font-size:9px;font-weight:600;color:#dc2626;">目标差 -3%</span><span style="padding:2px 6px;border-radius:4px;background:rgba(107,114,128,0.1);font-size:9px;font-weight:600;color:#6b7280;">同比 基本持平</span></div></div>
                </div>
                <div style="padding:14px;border-radius:12px;background:#ffffff;border:1px solid #eef2f6;box-shadow:0 2px 6px rgba(0,0,0,0.03);text-align:center;">
                  <div style="font-size:10px;color:#94a3b8;margin-bottom:6px;">签约额</div>
                  <div style="font-size:18px;font-weight:700;color:#0f172a;line-height:1.3;">243,483<span style="font-size:10px;font-weight:400;color:#94a3b8;margin-left:2px;">万元</span><div style="display:flex;gap:6px;margin-top:6px;justify-content:center;"><span style="padding:2px 6px;border-radius:4px;background:rgba(34,197,94,0.1);font-size:9px;font-weight:600;color:#16a34a;">目标完成 99.7%</span><span style="padding:2px 6px;border-radius:4px;background:rgba(34,197,94,0.1);font-size:9px;font-weight:600;color:#16a34a;">同比 +39.2%</span></div></div>
                </div>
                <div style="padding:14px;border-radius:12px;background:#ffffff;border:1px solid #eef2f6;box-shadow:0 2px 6px rgba(0,0,0,0.03);text-align:center;">
                  <div style="font-size:10px;color:#94a3b8;margin-bottom:6px;">综合毛利率</div>
                  <div style="font-size:18px;font-weight:700;color:#0f172a;line-height:1.3;">${fmtPct(
    marginData.summary.h1WeightedActual,
    1
  )}<span style="font-size:10px;font-weight:400;color:#94a3b8;margin-left:2px;">%</span><div style="display:flex;gap:6px;margin-top:6px;justify-content:center;"><span style="padding:2px 6px;border-radius:4px;background:rgba(239,68,68,0.1);font-size:9px;font-weight:600;color:#dc2626;">目标差 ${
  marginData.summary.targetGap >= 0 ? '+' : ''
}${fmtPct(
  marginData.summary.targetGap,
  1
)}%</span><span style="padding:2px 6px;border-radius:4px;background:rgba(239,68,68,0.1);font-size:9px;font-weight:600;color:#dc2626;">同比 ${
  marginData.summary.yoy >= 0 ? '+' : ''
}${fmtPct(marginData.summary.yoy, 1)}%</span></div></div>
                </div>
                <div style="padding:14px;border-radius:12px;background:#ffffff;border:1px solid #eef2f6;box-shadow:0 2px 6px rgba(0,0,0,0.03);text-align:center;">
                  <div style="font-size:10px;color:#94a3b8;margin-bottom:6px;">管理利润</div>
                  <div style="font-size:18px;font-weight:700;color:#0f172a;line-height:1.3;">398<span style="font-size:10px;font-weight:400;color:#94a3b8;margin-left:2px;">万元</span><div style="display:flex;gap:6px;margin-top:6px;justify-content:center;"><span style="padding:2px 6px;border-radius:4px;background:rgba(239,68,68,0.1);font-size:9px;font-weight:600;color:#dc2626;">目标完成 7.4%</span><span style="padding:2px 6px;border-radius:4px;background:rgba(251,191,36,0.15);font-size:9px;font-weight:600;color:#d97706;">利润质量待验证</span></div></div>
                </div>
                <div style="padding:14px;border-radius:12px;background:#ffffff;border:1px solid #eef2f6;box-shadow:0 2px 6px rgba(0,0,0,0.03);text-align:center;">
                  <div style="font-size:10px;color:#94a3b8;margin-bottom:6px;">人效</div>
                  <div style="font-size:18px;font-weight:700;color:#0f172a;line-height:1.3;">10.6<span style="font-size:10px;font-weight:400;color:#94a3b8;margin-left:2px;">%</span><div style="display:flex;gap:6px;margin-top:6px;justify-content:center;"><span style="padding:2px 6px;border-radius:4px;background:rgba(34,197,94,0.1);font-size:9px;font-weight:600;color:#16a34a;">目标完成 110%</span><span style="padding:2px 6px;border-radius:4px;background:rgba(239,68,68,0.1);font-size:9px;font-weight:600;color:#dc2626;">同比 -1.0pct</span></div></div>
                </div>
              </div>
            </div>
          </div>

          <div id="h1-section-3-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div id="h1-charts-loading-${reportId}" style="display:flex;height:400px;flex-direction:column;align-items:center;justify-content:center;gap:8px;">
              <div style="width:24px;height:24px;border:3px solid #e8ecf0;border-top:3px solid #4A5FF3;border-radius:50%;animation:cl-spin-${reportId} 0.8s linear infinite;"></div>
              <span style="font-size:11px;color:#94a3b8;">正在加载指标分析数据...</span>
            </div>
            <div id="h1-charts-content-${reportId}" style="display:none;">
              <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
                <div style="font-size:12px;font-weight:600;color:#1f2937;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4A5FF3" stroke-width="2"><path d="M18 20V10M8 20V4M3 18h18M4 20h16"/></svg><span style="margin-left:6px;">指标分析</span></div>
                <div style="font-size:10px;color:#94a3b8;">1—6 月月度经营走势</div>
              </div>
              <div id="${section3Id}" style="display:grid;grid-template-columns:repeat(2,1fr);gap:10px;">
                <div style="padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e2e8f0;">
                  <div style="margin-bottom:8px;">
                    <div style="font-size:11px;font-weight:600;color:#1f2937;margin-bottom:2px;">上半年（1-6月）收入情况</div>
                    <div style="font-size:10px;color:#94a3b8;"><span style="font-weight:600;color:#4A5FF3;">H1 累计 368,559 万元</span><span style="margin-left:4px;">目标完成 93% · 同比 +8%</span></div>
                  </div>
                  <div style="display:flex;gap:10px;margin-bottom:8px;">
                    <div style="display:flex;align-items:center;gap:3px;">
                      <div style="width:8px;height:2px;border-radius:1px;background:#4A5FF3;"></div>
                      <span style="font-size:9px;color:#6b7280;">整体收入</span>
                    </div>
                    <div style="display:flex;align-items:center;gap:3px;">
                      <div style="width:8px;height:2px;border-radius:1px;background:#64748b;"></div>
                      <span style="font-size:9px;color:#6b7280;">外单收入</span>
                    </div>
                  </div>
                  <div id="h1-chart-svg-${reportId}-0">
                    <svg width="100%" height="110" viewBox="0 0 280 110" preserveAspectRatio="none">
                      <defs>
                        <linearGradient id="revGrad-${reportId}" x1="0%" y1="0%" x2="0%" y2="100%">
                          <stop offset="0%" style="stop-color:#4A5FF3;stop-opacity:0.25"/>
                          <stop offset="100%" style="stop-color:#4A5FF3;stop-opacity:0"/>
                        </linearGradient>
                      </defs>
                      <line x1="35" y1="15" x2="35" y2="95" stroke="#e2e8f0" stroke-width="1"/>
                      <line x1="35" y1="35" x2="270" y2="35" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2,2"/>
                      <line x1="35" y1="55" x2="270" y2="55" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2,2"/>
                      <line x1="35" y1="75" x2="270" y2="75" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2,2"/>
                      <text x="28" y="20" text-anchor="end" font-size="8" fill="#94a3b8">60000</text>
                      <text x="28" y="40" text-anchor="end" font-size="8" fill="#94a3b8">45000</text>
                      <text x="28" y="60" text-anchor="end" font-size="8" fill="#94a3b8">30000</text>
                      <text x="28" y="80" text-anchor="end" font-size="8" fill="#94a3b8">15000</text>
                      <polyline points="55,31 90,30 125,16 160,14 195,13 230,15" stroke="#4A5FF3" stroke-width="2" fill="none"/>
                      <polyline points="55,31 90,30 125,16 160,14 195,13 230,15 230,95 55,95" fill="url(#revGrad-${reportId})"/>
                      <polyline points="55,73 90,75 125,70 160,67 195,69 230,66" stroke="#64748b" stroke-width="2" stroke-dasharray="4,2" fill="none"/>
                      <circle cx="55" cy="31" r="3" fill="#4A5FF3"/><circle cx="90" cy="30" r="3" fill="#4A5FF3"/><circle cx="125" cy="16" r="3" fill="#4A5FF3"/><circle cx="160" cy="14" r="3" fill="#4A5FF3"/><circle cx="195" cy="13" r="3" fill="#4A5FF3"/><circle cx="230" cy="15" r="3" fill="#4A5FF3"/>
                      <circle cx="55" cy="73" r="3" fill="#64748b"/><circle cx="90" cy="75" r="3" fill="#64748b"/><circle cx="125" cy="70" r="3" fill="#64748b"/><circle cx="160" cy="67" r="3" fill="#64748b"/><circle cx="195" cy="69" r="3" fill="#64748b"/><circle cx="230" cy="66" r="3" fill="#64748b"/>
                      <text x="55" y="103" text-anchor="middle" font-size="9" fill="#6b7280">1月</text>
                      <text x="90" y="103" text-anchor="middle" font-size="9" fill="#6b7280">2月</text>
                      <text x="125" y="103" text-anchor="middle" font-size="9" fill="#6b7280">3月</text>
                      <text x="160" y="103" text-anchor="middle" font-size="9" fill="#6b7280">4月</text>
                      <text x="195" y="103" text-anchor="middle" font-size="9" fill="#6b7280">5月</text>
                      <text x="230" y="103" text-anchor="middle" font-size="9" fill="#6b7280">6月</text>
                    </svg>
                  </div>
                </div>
                <div style="padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e2e8f0;">
                  <div style="margin-bottom:8px;">
                    <div style="font-size:11px;font-weight:600;color:#1f2937;margin-bottom:2px;">上半年（1-6月）签约情况</div>
                    <div style="font-size:10px;color:#94a3b8;"><span style="font-weight:600;color:#16a34a;">H1 累计 243,483 万元</span><span style="margin-left:4px;">目标完成 100% · 同比 +39%</span></div>
                  </div>
                  <div style="display:flex;gap:10px;margin-bottom:8px;">
                    <div style="display:flex;align-items:center;gap:3px;">
                      <div style="width:8px;height:2px;border-radius:1px;background:#16a34a;"></div>
                      <span style="font-size:9px;color:#6b7280;">整体签约</span>
                    </div>
                    <div style="display:flex;align-items:center;gap:3px;">
                      <div style="width:8px;height:2px;border-radius:1px;background:#64748b;"></div>
                      <span style="font-size:9px;color:#6b7280;">外单签约</span>
                    </div>
                  </div>
                  <div id="h1-chart-svg-${reportId}-1">
                    <svg width="100%" height="110" viewBox="0 0 280 110" preserveAspectRatio="none">
                      <defs>
                        <linearGradient id="signGrad-${reportId}" x1="0%" y1="0%" x2="0%" y2="100%">
                          <stop offset="0%" style="stop-color:#16a34a;stop-opacity:0.25"/>
                          <stop offset="100%" style="stop-color:#16a34a;stop-opacity:0"/>
                        </linearGradient>
                      </defs>
                      <line x1="35" y1="15" x2="35" y2="95" stroke="#e2e8f0" stroke-width="1"/>
                      <line x1="35" y1="35" x2="270" y2="35" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2,2"/>
                      <line x1="35" y1="55" x2="270" y2="55" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2,2"/>
                      <line x1="35" y1="75" x2="270" y2="75" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2,2"/>
                      <text x="28" y="20" text-anchor="end" font-size="8" fill="#94a3b8">60000</text>
                      <text x="28" y="40" text-anchor="end" font-size="8" fill="#94a3b8">45000</text>
                      <text x="28" y="60" text-anchor="end" font-size="8" fill="#94a3b8">30000</text>
                      <text x="28" y="80" text-anchor="end" font-size="8" fill="#94a3b8">15000</text>
                      <polyline points="55,63 90,60 125,46 160,25 195,44 230,41" stroke="#16a34a" stroke-width="2" fill="none"/>
                      <polyline points="55,63 90,60 125,46 160,25 195,44 230,41 230,95 55,95" fill="url(#signGrad-${reportId})"/>
                      <polyline points="55,64 90,66 125,50 160,30 195,52 230,46" stroke="#64748b" stroke-width="2" stroke-dasharray="4,2" fill="none"/>
                      <circle cx="55" cy="63" r="3" fill="#16a34a"/><circle cx="90" cy="60" r="3" fill="#16a34a"/><circle cx="125" cy="46" r="3" fill="#16a34a"/><circle cx="160" cy="25" r="3" fill="#16a34a"/><circle cx="195" cy="44" r="3" fill="#16a34a"/><circle cx="230" cy="41" r="3" fill="#16a34a"/>
                      <circle cx="55" cy="64" r="3" fill="#64748b"/><circle cx="90" cy="66" r="3" fill="#64748b"/><circle cx="125" cy="50" r="3" fill="#64748b"/><circle cx="160" cy="30" r="3" fill="#64748b"/><circle cx="195" cy="52" r="3" fill="#64748b"/><circle cx="230" cy="46" r="3" fill="#64748b"/>
                      <text x="55" y="103" text-anchor="middle" font-size="9" fill="#6b7280">1月</text>
                      <text x="90" y="103" text-anchor="middle" font-size="9" fill="#6b7280">2月</text>
                      <text x="125" y="103" text-anchor="middle" font-size="9" fill="#6b7280">3月</text>
                      <text x="160" y="103" text-anchor="middle" font-size="9" fill="#6b7280">4月</text>
                      <text x="195" y="103" text-anchor="middle" font-size="9" fill="#6b7280">5月</text>
                      <text x="230" y="103" text-anchor="middle" font-size="9" fill="#6b7280">6月</text>
                    </svg>
                  </div>
                </div>
                <div style="padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e2e8f0;">
                  <div style="margin-bottom:8px;">
                    <div style="font-size:11px;font-weight:600;color:#1f2937;margin-bottom:2px;">整体毛利率实际曲线</div>
                    <div style="font-size:10px;color:#94a3b8;"><span style="font-weight:600;color:#dc2626;">H1 平均 ${fmtPct(
    marginData.summary.h1WeightedActual,
    1
  )}%</span><span style="margin-left:4px;">目标 ${fmtPct(
  marginData.summary.h1Target,
  1
)}% · 同比 ${marginData.summary.yoy >= 0 ? '+' : ''}${fmtPct(
  marginData.summary.yoy,
  1
)}%</span></div>
                  </div>
                  <div id="h1-chart-svg-${reportId}-2">
                    <svg width="100%" height="110" viewBox="0 0 280 110" preserveAspectRatio="none">
                      <defs>
                        <linearGradient id="marginGrad-${reportId}" x1="0%" y1="0%" x2="0%" y2="100%">
                          <stop offset="0%" style="stop-color:#dc2626;stop-opacity:0.25"/>
                          <stop offset="100%" style="stop-color:#dc2626;stop-opacity:0"/>
                        </linearGradient>
                      </defs>
                      <line x1="35" y1="15" x2="35" y2="95" stroke="#e2e8f0" stroke-width="1"/>
                      <line x1="35" y1="35" x2="270" y2="35" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2,2"/>
                      <line x1="35" y1="55" x2="270" y2="55" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2,2"/>
                      <line x1="35" y1="75" x2="270" y2="75" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2,2"/>
                      <text x="28" y="20" text-anchor="end" font-size="8" fill="#94a3b8">22%</text>
                      <text x="28" y="40" text-anchor="end" font-size="8" fill="#94a3b8">18%</text>
                      <text x="28" y="60" text-anchor="end" font-size="8" fill="#94a3b8">14%</text>
                      <text x="28" y="80" text-anchor="end" font-size="8" fill="#94a3b8">10%</text>
                      <polyline points="55,41 90,42 125,42 160,55 195,52 230,42" stroke="#dc2626" stroke-width="2" fill="none"/>
                      <polyline points="55,41 90,42 125,42 160,55 195,52 230,42 230,95 55,95" fill="url(#marginGrad-${reportId})"/>
                      <circle cx="55" cy="41" r="3" fill="#dc2626"/><circle cx="90" cy="42" r="3" fill="#dc2626"/><circle cx="125" cy="42" r="3" fill="#dc2626"/><circle cx="160" cy="55" r="3" fill="#dc2626"/><circle cx="195" cy="52" r="3" fill="#dc2626"/><circle cx="230" cy="42" r="3" fill="#dc2626"/>
                      <text x="55" y="103" text-anchor="middle" font-size="9" fill="#6b7280">1月</text>
                      <text x="90" y="103" text-anchor="middle" font-size="9" fill="#6b7280">2月</text>
                      <text x="125" y="103" text-anchor="middle" font-size="9" fill="#6b7280">3月</text>
                      <text x="160" y="103" text-anchor="middle" font-size="9" fill="#6b7280">4月</text>
                      <text x="195" y="103" text-anchor="middle" font-size="9" fill="#6b7280">5月</text>
                      <text x="230" y="103" text-anchor="middle" font-size="9" fill="#6b7280">6月</text>
                    </svg>
                  </div>
                </div>
                <div style="padding:12px;border-radius:10px;background:#f8fafc;border:1px solid #e2e8f0;">
                  <div style="margin-bottom:8px;">
                    <div style="font-size:11px;font-weight:600;color:#1f2937;margin-bottom:2px;">上半年（1-6月）利润情况</div>
                    <div style="font-size:10px;color:#94a3b8;"><span style="font-weight:600;color:#4A5FF3;">H1 利润额 ${fmtPct(
    profitData.summary.h1Profit,
    0
  )} 万元</span><span style="margin-left:4px;">目标完成 ${fmtPct(
  profitData.summary.targetCompletion,
  1
)}% · 同比 ${profitData.summary.yoy >= 0 ? '+' : ''}${fmtPct(
  profitData.summary.yoy,
  1
)}%</span></div>
                  </div>
                  <div style="display:flex;gap:12px;margin-bottom:8px;">
                    <div style="display:flex;align-items:center;gap:3px;">
                      <div style="width:12px;height:6px;border-radius:2px;background:#4A5FF3;"></div>
                      <span style="font-size:9px;color:#6b7280;">利润额</span>
                    </div>
                    <div style="display:flex;align-items:center;gap:3px;">
                      <div style="width:8px;height:2px;border-radius:1px;background:#06b6d4;"></div>
                      <span style="font-size:9px;color:#6b7280;">利润达成率</span>
                    </div>
                    <div style="display:flex;align-items:center;gap:3px;">
                      <div style="width:8px;height:2px;border-radius:1px;background:#16a34a;"></div>
                      <span style="font-size:9px;color:#6b7280;">同比增幅</span>
                    </div>
                  </div>
                  <div id="h1-chart-svg-${reportId}-3">
                    <svg width="100%" height="110" viewBox="0 0 280 110" preserveAspectRatio="none">
                      <line x1="35" y1="15" x2="35" y2="95" stroke="#e2e8f0" stroke-width="1"/>
                      <line x1="35" y1="35" x2="270" y2="35" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2,2"/>
                      <line x1="35" y1="55" x2="270" y2="55" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2,2"/>
                      <line x1="35" y1="75" x2="270" y2="75" stroke="#e2e8f0" stroke-width="1" stroke-dasharray="2,2"/>
                      <text x="28" y="20" text-anchor="end" font-size="8" fill="#94a3b8">1200</text>
                      <text x="28" y="40" text-anchor="end" font-size="8" fill="#94a3b8">900</text>
                      <text x="28" y="60" text-anchor="end" font-size="8" fill="#94a3b8">600</text>
                      <text x="28" y="80" text-anchor="end" font-size="8" fill="#94a3b8">300</text>
                      <rect x="45" y="79" width="20" height="16" rx="4" fill="#4A5FF3"/><rect x="80" y="58" width="20" height="37" rx="4" fill="#4A5FF3"/><rect x="115" y="41" width="20" height="54" rx="4" fill="#4A5FF3"/><rect x="150" y="34" width="20" height="61" rx="4" fill="#4A5FF3"/><rect x="185" y="38" width="20" height="57" rx="4" fill="#4A5FF3"/><rect x="220" y="36" width="20" height="59" rx="4" fill="#4A5FF3"/>
                      <text x="55" y="74" text-anchor="middle" font-size="7" fill="#4A5FF3">237</text><text x="90" y="53" text-anchor="middle" font-size="7" fill="#4A5FF3">551</text><text x="125" y="36" text-anchor="middle" font-size="7" fill="#4A5FF3">808</text><text x="160" y="29" text-anchor="middle" font-size="7" fill="#4A5FF3">910</text><text x="195" y="33" text-anchor="middle" font-size="7" fill="#4A5FF3">856</text><text x="230" y="31" text-anchor="middle" font-size="7" fill="#4A5FF3">885</text>
                      <polyline points="55,52 90,60 125,69 160,63 195,69 230,59" stroke="#06b6d4" stroke-width="2" stroke-dasharray="4,2" fill="none"/>
                      <circle cx="55" cy="52" r="3" fill="#06b6d4"/><circle cx="90" cy="60" r="3" fill="#06b6d4"/><circle cx="125" cy="69" r="3" fill="#06b6d4"/><circle cx="160" cy="63" r="3" fill="#06b6d4"/><circle cx="195" cy="69" r="3" fill="#06b6d4"/><circle cx="230" cy="59" r="3" fill="#06b6d4"/>
                      <polyline points="55,53 90,25 125,65 160,55 195,59 230,62" stroke="#16a34a" stroke-width="2" fill="none"/>
                      <circle cx="55" cy="53" r="3" fill="#16a34a"/><circle cx="90" cy="25" r="3" fill="#16a34a"/><circle cx="125" cy="65" r="3" fill="#16a34a"/><circle cx="160" cy="55" r="3" fill="#16a34a"/><circle cx="195" cy="59" r="3" fill="#16a34a"/><circle cx="230" cy="62" r="3" fill="#16a34a"/>
                      <text x="55" y="103" text-anchor="middle" font-size="9" fill="#6b7280">1月</text>
                      <text x="90" y="103" text-anchor="middle" font-size="9" fill="#6b7280">2月</text>
                      <text x="125" y="103" text-anchor="middle" font-size="9" fill="#6b7280">3月</text>
                      <text x="160" y="103" text-anchor="middle" font-size="9" fill="#6b7280">4月</text>
                      <text x="195" y="103" text-anchor="middle" font-size="9" fill="#6b7280">5月</text>
                      <text x="230" y="103" text-anchor="middle" font-size="9" fill="#6b7280">6月</text>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="h1-section-4-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
              <div style="font-size:12px;font-weight:600;color:#1f2937;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4A5FF3" stroke-width="2"><path d="M12 2v20M2 12h20"/></svg><span style="margin-left:6px;">经营指标全景</span></div>
              <div style="font-size:10px;color:#94a3b8;">pct 为百分点</div>
            </div>
            <div id="h1-table-loading-${reportId}" style="display:flex;height:200px;flex-direction:column;align-items:center;justify-content:center;gap:8px;background:#f8fafc;border-radius:8px;">
              <div style="width:24px;height:24px;border:3px solid #e8ecf0;border-top:3px solid #4A5FF3;border-radius:50%;animation:cl-spin-${reportId} 0.8s linear infinite;"></div>
              <span style="font-size:11px;color:#94a3b8;">正在加载指标数据...</span>
            </div>
            <div id="h1-table-content-${reportId}" style="display:none;">
              <div style="overflow-x:auto;">
                <table style="width:100%;border-collapse:collapse;font-size:11px;">
                  <thead>
                    <tr style="border-bottom:1px solid #e8ecf0;">
                      <th style="text-align:left;padding:8px;color:#6b7280;font-weight:600;">指标</th>
                      <th style="text-align:right;padding:8px;color:#6b7280;font-weight:600;">年度目标</th>
                      <th style="text-align:right;padding:8px;color:#6b7280;font-weight:600;">H1目标</th>
                      <th style="text-align:right;padding:8px;color:#6b7280;font-weight:600;">H1实际</th>
                      <th style="text-align:right;padding:8px;color:#6b7280;font-weight:600;">同期</th>
                      <th style="text-align:right;padding:8px;color:#6b7280;font-weight:600;">完成/差距</th>
                      <th style="text-align:right;padding:8px;color:#6b7280;font-weight:600;">同比</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style="border-bottom:1px solid #f3f4f6;"><td style="padding:8px;color:#374151;">收入</td><td style="text-align:right;padding:8px;color:#374151;">800,000</td><td style="text-align:right;padding:8px;color:#374151;">397,859</td><td style="text-align:right;padding:8px;color:#374151;">368,559</td><td style="text-align:right;padding:8px;color:#374151;">340,310</td><td style="text-align:right;padding:8px;color:#d97706;font-weight:600;">92.6%</td><td style="text-align:right;padding:8px;color:#16a34a;font-weight:600;">+8.3%</td></tr>
                    <tr style="border-bottom:1px solid #f3f4f6;"><td style="padding:8px;color:#374151;">外单占比</td><td style="text-align:right;padding:8px;color:#374151;">51.1%</td><td style="text-align:right;padding:8px;color:#374151;">47.3%</td><td style="text-align:right;padding:8px;color:#374151;">43.1%</td><td style="text-align:right;padding:8px;color:#374151;">44.8%</td><td style="text-align:right;padding:8px;color:#d97706;font-weight:600;">-3.0%</td><td style="text-align:right;padding:8px;color:#6b7280;font-weight:600;">基本持平</td></tr>
                    <tr style="border-bottom:1px solid #f3f4f6;"><td style="padding:8px;color:#374151;">外单收入</td><td style="text-align:right;padding:8px;color:#374151;">408,560</td><td style="text-align:right;padding:8px;color:#374151;">189,104</td><td style="text-align:right;padding:8px;color:#374151;">158,824</td><td style="text-align:right;padding:8px;color:#374151;">149,024</td><td style="text-align:right;padding:8px;color:#dc2626;font-weight:600;">84.0%</td><td style="text-align:right;padding:8px;color:#16a34a;font-weight:600;">+6.6%</td></tr>
                    <tr style="border-bottom:1px solid #f3f4f6;"><td style="padding:8px;color:#374151;">签约额</td><td style="text-align:right;padding:8px;color:#374151;">535,636</td><td style="text-align:right;padding:8px;color:#374151;">244,213</td><td style="text-align:right;padding:8px;color:#374151;">243,483</td><td style="text-align:right;padding:8px;color:#374151;">174,867</td><td style="text-align:right;padding:8px;color:#16a34a;font-weight:600;">99.7%</td><td style="text-align:right;padding:8px;color:#16a34a;font-weight:600;">+39.2%</td></tr>
                    <tr style="border-bottom:1px solid #f3f4f6;"><td style="padding:8px;color:#374151;">毛利率</td><td style="text-align:right;padding:8px;color:#374151;">20.5%</td><td style="text-align:right;padding:8px;color:#374151;">19.4%</td><td style="text-align:right;padding:8px;color:#374151;">15.9%</td><td style="text-align:right;padding:8px;color:#374151;">18.2%</td><td style="text-align:right;padding:8px;color:#dc2626;font-weight:600;">81.8%</td><td style="text-align:right;padding:8px;color:#dc2626;font-weight:600;">-2.3%</td></tr>
                    <tr style="border-bottom:1px solid #f3f4f6;"><td style="padding:8px;color:#374151;">管理利润</td><td style="text-align:right;padding:8px;color:#374151;">20,000</td><td style="text-align:right;padding:8px;color:#374151;">5,395</td><td style="text-align:right;padding:8px;color:#374151;">398</td><td style="text-align:right;padding:8px;color:#374151;">2,464</td><td style="text-align:right;padding:8px;color:#dc2626;font-weight:600;">7.4%</td><td style="text-align:right;padding:8px;color:#dc2626;font-weight:600;">-83.8%</td></tr>
                    <tr style="border-bottom:1px solid #f3f4f6;"><td style="padding:8px;color:#374151;">费用率</td><td style="text-align:right;padding:8px;color:#374151;">5.7%</td><td style="text-align:right;padding:8px;color:#374151;">5.6%</td><td style="text-align:right;padding:8px;color:#374151;">6.9%</td><td style="text-align:right;padding:8px;color:#374151;">5.8%</td><td style="text-align:right;padding:8px;color:#dc2626;font-weight:600;">+1.2%</td><td style="text-align:right;padding:8px;color:#dc2626;font-weight:600;">+0.2%</td></tr>
                    <tr style=""><td style="padding:8px;color:#374151;">人效</td><td style="text-align:right;padding:8px;color:#374151;">11.0%</td><td style="text-align:right;padding:8px;color:#374151;">11.8%</td><td style="text-align:right;padding:8px;color:#374151;">10.6%</td><td style="text-align:right;padding:8px;color:#374151;">11.6%</td><td style="text-align:right;padding:8px;color:#d97706;font-weight:600;">-1.2%</td><td style="text-align:right;padding:8px;color:#dc2626;font-weight:600;">-1.0%</td></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div id="h1-section-5-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">
              <div style="font-size:12px;font-weight:600;color:#1f2937;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4A5FF3" stroke-width="2"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg><span style="margin-left:6px;">关键经营判断</span></div>
            </div>
            <div id="${section5Id}" style="display:flex;flex-direction:column;gap:10px;">
              ${findings
    .map(
      (f, i) => `
                <div id="h1-finding-card-${reportId}-${i}" style="display:none;padding:12px;border-radius:10px;background:#f8fafc;border-left:3px solid #4A5FF3;">
                  <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
                    <span style="padding:2px 6px;border-radius:4px;background:rgba(74,95,243,0.1);font-size:10px;font-weight:700;color:#4A5FF3;">${f.id}</span>
                    <span id="h1-finding-title-${reportId}-${i}" style="font-size:12px;font-weight:600;color:#1f2937;"></span>
                  </div>
                  <div id="h1-finding-${reportId}-${i}" style="font-size:11px;color:#5a6b7e;line-height:1.6;min-height:22px;"></div>
                </div>
              `
    )
    .join('')}
            </div>
          </div>

          <div id="h1-section-6-${reportId}" style="padding:14px 15px;border-radius:12px;background:#ffffff;border:1px solid #e8ecf0;display:none;">
            <div style="font-size:12px;font-weight:600;color:#1f2937;margin-bottom:10px;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2"><path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/></svg><span style="margin-left:6px;">推荐问题</span></div>
            <div style="display:flex;flex-wrap:wrap;gap:8px;">
              <button type="button" data-smart-action="chain-performance-breakdown" style="padding:8px 14px;border-radius:8px;background:linear-gradient(135deg,rgba(74,95,243,0.08),rgba(74,95,243,0.03));border:1px solid rgba(74,95,243,0.15);font-size:11px;color:#4A5FF3;cursor:pointer;transition:all 0.2s ease;display:flex;align-items:center;gap:6px;" onmouseover="this.style.background='linear-gradient(135deg,rgba(74,95,243,0.12),rgba(74,95,243,0.06))';this.style.borderColor='rgba(74,95,243,0.25)'" onmouseout="this.style.background='linear-gradient(135deg,rgba(74,95,243,0.08),rgba(74,95,243,0.03))';this.style.borderColor='rgba(74,95,243,0.15)'">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#4A5FF3" stroke-width="2"><path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/></svg>
                <span>业绩解构</span>
              </button>
              
            </div>
          </div>
        </div>
      `
      if (staticMsgId) {
        console.log('[H1_CARD] Entering staticMsgId branch, setting cardHtml')
        this.$store.commit('cosmoClaw/UPDATE_MESSAGE_CONTENT_BY_ID', {
          id: staticMsgId,
          content: cardHtml,
          richHtml: true
        })
        var s = this
        return new Promise(function (resolve) {
          s.$nextTick(function () {
            for (var si = 0; si <= 6; si++) {
              var el = s._findVisibleEl('h1-section-' + si + '-' + reportId)
              if (el) el.style.display = 'block'
            }
            var st = function (id, txt) {
              var e = s._findVisibleEl(id)
              if (e) e.textContent = txt
            }
            st('h1-s0-label-' + reportId, '上半年经营复盘')
            st('h1-s0-title-' + reportId, '上半年卡奥斯经营业绩分析')
            st('h1-s0-date-' + reportId, '2026 年上半年 · 单位：万元')
            st('h1-s1-headline-' + reportId, headlineText)
            st(reportId + '-span', verdictText)
            var sc = function (lid, cid) {
              var l = s._findVisibleEl(lid)
              if (l) l.style.display = 'none'
              var c = s._findVisibleEl(cid)
              if (c) c.style.display = 'block'
            }
            sc('h1-metrics-loading-' + reportId, 'h1-metrics-content-' + reportId)
            sc('h1-charts-loading-' + reportId, 'h1-charts-content-' + reportId)
            sc('h1-table-loading-' + reportId, 'h1-table-content-' + reportId)
            findings.forEach(function (ff, ii) {
              var fc = s._findVisibleEl('h1-finding-card-' + reportId + '-' + ii)
              if (fc) fc.style.display = 'block'
              st('h1-finding-title-' + reportId + '-' + ii, ff.title)
              st('h1-finding-' + reportId + '-' + ii, ff.desc)
            })
            resolve()
          })
        })
      }
      console.log('[H1_CARD] Falling through to animation code! staticMsgId was:', staticMsgId)
      this.appendLocalMessage('assistant', cardHtml, true)
      this.persistMockMessage('assistant', '[mock:ceo-h1-summary]')

      // 串行揭示：全部文字打印机效果，按顺序逐渐展示
      setTimeout(() => {
        this.revealSection(`h1-section-0-${reportId}`, 'block')
        // Section 0: 流式输出 3 行 header 文字
        setTimeout(() => {
          this.typeWriterEffect(`h1-s0-label-${reportId}`, '上半年经营复盘', () => {
            this.typeWriterEffect(
              `h1-s0-title-${reportId}`,
              '上半年卡奥斯经营业绩分析',
              () => {
                this.typeWriterEffect(
                  `h1-s0-date-${reportId}`,
                  '2026 年上半年 · 单位：万元',
                  () => {
                    // header 打字完毕 → 结论
                    this.revealSection(`h1-section-1-${reportId}`, 'block')
                    setTimeout(() => {
                      this.typeWriterEffect(
                        `h1-s1-headline-${reportId}`,
                        headlineText,
                        () => {
                          this.typeWriterEffect(`${section1Id}-span`, verdictText, () => {
                            // 结论打字完毕 → 核心看板
                            this.revealSection(`h1-section-2-${reportId}`, 'block')
                            // loading 后一次性展示所有指标卡片
                            setTimeout(() => {
                              const metricsLoader = this._findVisibleEl(
                                `h1-metrics-loading-${reportId}`
                              )
                              const metricsContent = this._findVisibleEl(
                                `h1-metrics-content-${reportId}`
                              )
                              if (metricsLoader) metricsLoader.style.display = 'none'
                              if (metricsContent) metricsContent.style.display = 'block'
                              // 指标完毕 → 图表区域（整体loading → 一次性展示所有内容）
                              this.revealSection(`h1-section-3-${reportId}`, 'block')
                              setTimeout(() => {
                                const chartsLoader = this._findVisibleEl(
                                  `h1-charts-loading-${reportId}`
                                )
                                const chartsContent = this._findVisibleEl(
                                  `h1-charts-content-${reportId}`
                                )
                                if (chartsLoader) chartsLoader.style.display = 'none'
                                if (chartsContent) chartsContent.style.display = 'block'
                                // 图表完毕 → 经营指标全景表格
                                setTimeout(() => {
                                  this.revealSection(`h1-section-4-${reportId}`, 'block')
                                  // loading 后一次性展示全部表格数据
                                  setTimeout(() => {
                                    const tableLoader = this._findVisibleEl(
                                      `h1-table-loading-${reportId}`
                                    )
                                    const tableContent = this._findVisibleEl(
                                      `h1-table-content-${reportId}`
                                    )
                                    if (tableLoader) tableLoader.style.display = 'none'
                                    if (tableContent) {
                                      tableContent.style.display = 'block'
                                    }
                                    // 表格完毕 → 关键经营判断
                                    setTimeout(() => {
                                      this.revealSection(
                                        `h1-section-5-${reportId}`,
                                        'block'
                                      )
                                      // 逐个揭示 finding 卡片：先显示卡片，再流式输出标题+描述
                                      let fIdx = 0
                                      const typeNextFinding = () => {
                                        if (fIdx < findings.length) {
                                          const card = this._findVisibleEl(
                                            `h1-finding-card-${reportId}-${fIdx}`
                                          )
                                          if (card) card.style.display = 'block'
                                          this.typeWriterEffect(
                                            `h1-finding-title-${reportId}-${fIdx}`,
                                            findings[fIdx].title,
                                            () => {
                                              this.typeWriterEffect(
                                                `h1-finding-${reportId}-${fIdx}`,
                                                findings[fIdx].desc,
                                                () => {
                                                  fIdx++
                                                  setTimeout(typeNextFinding, 200)
                                                }
                                              )
                                            }
                                          )
                                        } else {
                                          this.revealSection(
                                            `h1-section-6-${reportId}`,
                                            'block'
                                          )
                                        }
                                      }
                                      setTimeout(typeNextFinding, 300)
                                    }, 200)
                                  }, 1200)
                                }, 200)
                              }, 1200)
                            }, 800)
                          })
                        }
                      )
                    }, 280)
                  }
                )
              }
            )
          })
        }, 200)
      }, 200)
    }
  }
}
